import * as React from 'react';
import withStyles from 'react-jss';
import { connect } from 'react-redux';
import Form from 'antd/lib/form';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Select from 'antd/lib/select';
import message from 'antd/lib/message';
import Tooltip from 'antd/lib/tooltip';
import InputNumber from 'antd/lib/input-number';
import DatePicker from 'antd/lib/date-picker';
import Input from 'antd/lib/input';
import Divider from 'antd/lib/divider';
import Timeline from 'antd/lib/timeline';
import Icon from 'antd/lib/icon';
import Spin from 'antd/lib/spin';
import Upload from 'antd/lib/upload';
import Button from 'antd/lib/button';
import { Dropdown, Menu , Radio } from 'antd';
import { CargoType } from './Booking/BookingUtils';
import { useGenericState } from 'src/Library/UseGenericState';
import {
  isValidArray,
  getPropertyValue,
  stops,
  isValidString,
  isValidNumber,
  highlightDiv,
  clone,
} from 'src/Library/Helper';
import AddLocationModal from './Modals/AddLocationModal';
import AddCfsLocationModal from './Modals/AddCfsLocationModal';
import {
  LocationPreferences,
  termsConditionsPlaceholder,
  disableInquiryClosingDateUtil,
  disableInquiryClosingTimeUtil,
  productTempValidation,
  BookingSource,
  resolveFieldLabel,
  ProductVehicleRuleSet,
  DEFAULT_PRODUCT_TYPE,
  masterVehicleTypes,
} from './InquiryUtils';
import { useDebounce } from 'src/hooks/useDebounce';
import moment, { Moment } from 'moment';
 
import { Ports , ContainerList } from 'src/components/common/Types/CommonTypes';
import { fetchAddresses, getDistanceBetweenAddresses } from 'src/api/organisationProfiling';
import { fetchAllStakeholdersPaginated } from 'src/api/masters';
import { renderAddressDetails } from './Cards/InquiryCommon';
import { fileUploadOnS3 } from 'src/api/inquiry';
import { CreateEnquiryFormConfig, Doc, Docs, MAX_DOMESTIC_STOP_LOCATIONS, DOMESTION_STOP_LOCATION_MAX_LENGTH, EXCLUDED_WEIGHT_UNITS } from './constants';
import { InquiryModes, InquiryType, DistanceConverterMap, CargoOperationType, CargoTypes } from 'src/Library/Constants';
import classNames from 'classnames';
import NewProduct from '../masters/Product/NewProduct';
import debounce from 'lodash/debounce';
import { searchProduct } from '../masters/Product/Product.api';
import { getFileExtension, arrayToObject, prettifyString } from 'src/utils/utils';
import { uploadImageToS3 } from 'src/api/salesorder';
import Asterisk from 'src/components/common/Asterisk';
const RadioGroup = Radio.Group;
const { RangePicker } = DatePicker;
import SelectAddress from 'src/components/common/CommonSelect/SelectAddress';
import { hasMasterCategoryEditPermission } from 'src/utils/partsToShow/helper';
import { tokens } from 'src/design-system';

const styles = (theme) => ({
  additionalDetailsRow: {
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'center',
    marginRight: '30px',
    verticalAlign: 'middle',
  },
  dot: {
    height: '8px',
    width: '8px',
    borderRadius: '5px',
    border: '1px solid #979797',
  },
  dotFilled: {
    backgroundColor: 'rgb(217, 217, 217)',
  },
  dottedCircle: {
    height: '8px',
    width: '8px',
    borderRadius: `${tokens.radius.md}px`,
    border: '2px dotted #cfcfcf',
  },
  lineFilled: {
    height: '20px',
    width: '2px',
    backgroundColor: '#e8e8e8'
  },
  noTimelineHeadPadding: {
    '& > .ant-timeline-item-head': {
      padding:'0',
    },
  },
  fontItalic: {
    color: '#666666',
    fontSize: `${tokens.fontSize.small}px`,
    fontStyle: 'italic',
    lineHeight: '6px',
  },
  checkboxFont: {
    fontSize: `${tokens.fontSize.caption}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: '#666666',
  },
  selectBorder: {
    '& .ant-select-selection': {
      border: 'none',
      boxShadow: 'none',
    },
  },
  cargoColumn: {
    border: '1px solid #D9D9D9',
    borderRadius: `${tokens.radius.md}px`,
    height: '32px',
    display: 'flex',
    paddingRight: 0,
  },
  cargoFontItem: {
    '& .ant-form-item-control': {
      lineHeight: '30px',
    },
  },
  addNewSelect: {
    display: 'flex',
    flexWrap: 'nowrap',
    color: tokens.colors.primary,
    padding: '6px 6px 10px',
  },
  locationType: {
    border: '1px solid #FFC83C',
    padding: '2px',
    borderRadius: '7px',
    marginTop: '8px',
    backgroundColor: '#FFFBD0',
    height: '100%',
    fontSize: '8px',
  },
  stuffingDropdown: {
    // '& .ant-select-dropdown-menu-item:not(:last-child)': {
      borderBottom: '1px solid #EDEDED',
      paddingBottom: '6px',
      width: '30%',
    // },
  },
  getDistanceButton: {
    padding: '5px 10px',
    border: '1px solid #86ACFF',
    color: '#86ACFF'
  },
  stopLocationTag: {
    fontSize: '11px',
    padding: '2px 8px',
    marginLeft: '5px',
    borderRadius: '10px'
  },
  stopLocationTagPickup: {
    backgroundColor: '#fff0dc'
  },
  stopLocationTagDelivery: {
    backgroundColor: '#dceeff'
  },
});

interface StateProps {
  vehicleDetails: any [];
  activeKey?: string | string[];
  openNewLocationModal: boolean;
  openCFSLocationModal: boolean;
  searchTerm: string;
  isPortSearching: boolean;
  ports: Ports [];
  cfsAddresses: any [];
  isAddressLoading: boolean;
  cfsLocation: any;
  isPrefilling?: boolean;
  prefillData?;
  // countrySelected: string;
  stuffingAddresses;
  deStuffingAddresses;
  packagingDetails;
  preferredSailingRange: [
    Moment,
    Moment,
  ];
  isProductListLoading: boolean;
  fetchingDistance: boolean;
  addProduct: boolean;
  productDetailList: Array<any>;
  stopLocationData: Array<any>;
  productDetails: any;
  productDetailsKey: number;
  inquiryFieldLabelMap: any;
  stakeholderList: any[];
  stakeholder: any;
  stakeholderSearching: boolean;
  stakeholderType: string;
  customerList: any[];
  customer: any;
  customerSearching: boolean;
  productVehicleRuleSet: ProductVehicleRuleSet | null;
}

const Option = Select.Option;
const FormItem = Form.Item;

const CreateDomesticInquiry = (props) => {
  const {
    parentClasses,
    form,
    classes,
    cargoTypes,
    cargoList,
    currencies,
    trailerType,
    domesticVehicleTypeSizeList,
    defaultDomesticVehicleSize,
    orgMaster,
    setStuffingTruckingAddress,
    setDeStuffingTruckingAddress,
    stuffingAddressObj,
    deStuffingAddressObj,
    loadAddresses,
    cfsAddressesList,
    weightsUnits,
    termsAndConditions,
    prefilling,
    prefilledVehicleDetails,
    prefilledCfsLocation,
    isBooking,
    inquiryId,
    shipperId,
    organisationId,
    isEdit,
    stuffingAddressesList,
    deStuffingAddressesList,
    // selectedCountryId,
    prefilledTermsAndConditions,
    isTemperatureControlledMandatory,
    reeferProductTempRange,
    defaultDeadlineInHours,
    docs,
    containerKey,
    updateDomesticDocsParent,
    stopLocationKeys,
    updateStopLocationKeys,
    packagingDetailsKeys,
    updateDomesticPackagingDetailsKeysParent,
    defaultDistanceUnit,
    stopsAddressData,
    defaultCargoSpecificGrossWeight,
    defaultVehicleSpecificTnC,
    customFieldsForInquiryDomestic,
    draftMandatoryFields,
    docsKey,
    isRPTL,
    productTypes,
    masterData,
    discoverRatesSelectedFilters,
    userData,
    productDetails: propsProductDetails,
    productDetailsKey: propsProductDetailsKey,
    productDetailList: propsProductDetailList,
    productVehicleRuleSet: propsProductVehicleRuleSet,
    inquiryFormPrefill,
    prefilledStakeholder,
    prefilledStakeholderList,
    prefilledCustomer,
    prefilledCustomerList,
    prefilledOriginIncharge,
    prefilledDestinationIncharge,
  } = props;
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  const [state, setState] = useGenericState<StateProps>({
    vehicleDetails: [{ }],
    activeKey: undefined,
    openNewLocationModal: false,
    openCFSLocationModal: false,
    searchTerm: '',
    isPortSearching: false,
    ports: [],
    cfsAddresses: cfsAddressesList,
    isAddressLoading: true,
    cfsLocation: {},
    // countrySelected: selectedCountryId,
    stuffingAddresses: stuffingAddressesList,
    deStuffingAddresses: deStuffingAddressesList,
    packagingDetails: undefined,
    preferredSailingRange: [
      moment().endOf('day').add(7, 'day'),
      moment().endOf('day').add(14, 'day'),
    ],
    isProductListLoading: false,
    addProduct: false,
    fetchingDistance: false,
    productDetailList: propsProductDetailList || [],
    stopLocationData: (stopsAddressData || [])?.map((item) => (item.type)) || [],
    productDetails: propsProductDetails && Object.keys(propsProductDetails).length > 0 
      ? propsProductDetails 
      : { 0: { key: '', quantity: 0, unit: 'kg', productCnType: '', productCnSize: '', containerAndQuantityDetails: [] } },
    productDetailsKey: propsProductDetailsKey || 1,
    inquiryFieldLabelMap: {},
    stakeholderList: prefilledStakeholderList?.length ? prefilledStakeholderList : [],
    stakeholder: prefilledStakeholder || undefined,
    stakeholderSearching: false,
    stakeholderType: 'Supplier',
    customerList: prefilledCustomerList?.length ? prefilledCustomerList : [],
    customer: prefilledCustomer || undefined,
    customerSearching: false,
    productVehicleRuleSet: propsProductVehicleRuleSet || null,
  });
  const latestDocsRef = React.useRef(props.docs);
  const {
    vehicleDetails,
    openNewLocationModal,
    openCFSLocationModal,
    searchTerm,
    isPortSearching,
    ports,
    cfsAddresses,
    isAddressLoading,
    cfsLocation,
    isPrefilling,
    prefillData,
    // countrySelected,
    stuffingAddresses,
    deStuffingAddresses,
    preferredSailingRange,
    stopLocationData,
    productDetailsKey,
    inquiryFieldLabelMap,
    stakeholderList,
    stakeholder,
    stakeholderSearching,
    stakeholderType,
    customerList,
    customer,
    customerSearching,
  } = state;
  const latestProductSearchRequestId = React.useRef(0);

  React.useEffect(() => {
    latestDocsRef.current = props.docs;
  }, [props.docs]);


  React.useEffect(() => {
    if (!prefilling) {
      setState({
        vehicleDetails: prefilledVehicleDetails || [{ }],
        cfsLocation: prefilledCfsLocation,
      });
    }
    const pickupPortCode = JSON.parse(getFieldValue('pickupPort')?.key || '{}')?.code;
    const dropOffPortCode = JSON.parse(getFieldValue('dropOffPort')?.key || '{}')?.code;
    const preferredSailingRange = getFieldValue('preferredSailingRange');
    if (preferredSailingRange)
      setState({ preferredSailingRange });
    setContainerDropOffCheck(pickupPortCode, dropOffPortCode);
  }, [prefilling]);

  const disableInquiryClosingDate = (current: any) => {
    let condition = disableInquiryClosingDateUtil(current);
    return (
      condition ||
      (preferredSailingRange?.[1] &&
        current &&
        current > state.preferredSailingRange[1].clone().endOf('day'))
    );
  };

  const setContainerDropOffCheck = (pickupPortCode, dropOffPortCode) => {
    if (!prefilling && pickupPortCode && pickupPortCode === dropOffPortCode &&
      trailerType === InquiryType.EXPORT) {
      setFieldsValue({ containerDropOffCheck: true });
    } else {
      setFieldsValue({ containerDropOffCheck: false });
    }
  }

  React.useEffect(() => {
    if (!isBooking && !isEdit && !inquiryId) {
      prefillDataInForm();
    }  
    
    if (!prefilling && !isEdit && !isBooking && !inquiryId) {
      setStuffingTruckingAddress(undefined);
      setDeStuffingTruckingAddress(undefined);
      setState({ cfsLocation: undefined });
      // if all the location fields are empty on changing trailer type, country selected should reset
      if (
        !form.getFieldValue('stuffingAddress') &&
        !form.getFieldValue('deStuffingAddress') &&
        !form.getFieldValue('dropOffPort') &&
        !form.getFieldValue('cfsLocation') &&
        !form.getFieldValue('pickupPort')
      ) {
        // setState({ countrySelected: undefined });
      }
    }
  }, [trailerType]);

  const stakeholderSearchTimeoutRef = React.useRef<any>(null);
  const customerSearchTimeoutRef = React.useRef<any>(null);

  const handleStakeholderSearch = (searchStakeholderType: 'SUPPLIER' | 'SHIPPER', queryString?: string) => {
    setState({ stakeholderSearching: true });
    if (stakeholderSearchTimeoutRef.current) {
      clearTimeout(stakeholderSearchTimeoutRef.current);
    }
    stakeholderSearchTimeoutRef.current = setTimeout(async () => {
      try {
        const response = await fetchAllStakeholdersPaginated({
          stakeholderType: [searchStakeholderType],
          searchQuery: queryString,
          resultPerPage: 25,
          currentPageNumber: 1,
        });
        if (response.isSuccess) {
          const stakeholderData = response.data?.data;
          setState({ stakeholderList: stakeholderData });
          return;
        }
      } catch (e) {
        message.error(e);
      } finally {
        setState({ stakeholderSearching: false });
      }
    }, 200);
  };

  const handleCustomerSearch = (queryString?: string) => {
    setState({ customerSearching: true });
    if (customerSearchTimeoutRef.current) {
      clearTimeout(customerSearchTimeoutRef.current);
    }
    customerSearchTimeoutRef.current = setTimeout(async () => {
      try {
        const response = await fetchAllStakeholdersPaginated({
          stakeholderType: ['CUSTOMER'],
          searchQuery: queryString,
          resultPerPage: 25,
          currentPageNumber: 1,
        });
        if (response.isSuccess) {
          const customerData = response.data?.data;
          setState({ customerList: customerData });
          return;
        }
      } catch (e) {
        message.error(e);
      } finally {
        setState({ customerSearching: false });
      }
    }, 200);
  };

  const handleStakeholderChange = (stakeholder: any) => {

    const stakeholderAddress = stakeholder?.defaultLocation;
    const addressLabel = `${stakeholderAddress?.name ?? ''}, ${stakeholderAddress?.pincode ?? ''} (${stakeholderAddress?.referenceNumber ?? ''})`;
    const stakeholderInchargeDetails = stakeholder?.picDetails;
    const stakeholderProducts = stakeholder?.productDetails;

    const formValuesToSet = {
        stuffingAddress: stakeholderAddress ? {
          key: stakeholderAddress?.id && String(stakeholderAddress.id),
          label: addressLabel
        }: undefined,
        originInchargePhone: stakeholderInchargeDetails?.phone,
        originInchargeEmail: stakeholderInchargeDetails?.email,
        originInchargeName: stakeholderInchargeDetails?.name
    };

    // Default vehicle type from stakeholder (when exportBehavior is not enabled)
    if (inquiryFormPrefill && !isRPTL) {
      const shouldUseStakeholderDefaults = !props.exportBehaviorEnabled;

      if (shouldUseStakeholderDefaults) {
        // Set default product list from stakeholder
        if (stakeholderProducts?.length > 0) {
          const mappedProducts = stakeholderProducts.map((item) => ({
            disabled: item.status === 'INACTIVE',
            key: item.id,
            referenceNumber: item.referenceNumber,
            label: `${item.internalName} (${item.hsCode} - ${item.remark}) [${item.referenceNumber}]`,
            value: item.internalName,
            organisationId: item.organisationId,
            cargoType: item.cargoType,
            cargoProductType: item.cargoProductType,
            containerAndQuantityDetails: item.containerAndQuantityDetails,
          }));
          setState({ productDetailList: mappedProducts });
        } else {
          setState({ productDetailList: [] });
        }

      }
    }

    form.setFieldsValue({
      ...formValuesToSet
    });

    setStuffingTruckingAddress(stakeholderAddress ? {
      city: stakeholderAddress?.city,
      countryId: stakeholderAddress?.countryId,
      address: stakeholderAddress?.address,
      state: stakeholderAddress?.state,
      pincode: stakeholderAddress?.pincode,
      name: stakeholderAddress?.name,
    } : undefined);

  };

  const handleCustomerChange = (customer: any) => {
    const customerAddress = customer?.defaultLocation
    const addressLabel = `${customerAddress?.name ?? ''}, ${customerAddress?.pincode ?? ''} (${customerAddress?.referenceNumber ?? ''})`
    const customerInchargeDetails = customer?.picDetails

    const formValuesToSet = {
        deStuffingAddress: customerAddress ? {
          key: customerAddress?.id && String(customerAddress.id),
          label: addressLabel
        }: undefined,
        destinationInchargePhone: customerInchargeDetails?.phone,
        destinationInchargeEmail: customerInchargeDetails?.email,
        destinationInchargeName: customerInchargeDetails?.name
    }

    form.setFieldsValue({
      ...formValuesToSet
    })

    setDeStuffingTruckingAddress(customerAddress ? {
      city: customerAddress?.city,
      countryId: customerAddress?.countryId,
      address: customerAddress?.address,
      state: customerAddress?.state,
      pincode: customerAddress?.pincode,
      name: customerAddress?.name,
    } : undefined);
  };
  
  const prefillDataInForm = async () => {
    setState({ isPrefilling: false });
  }

  // const prefillTruckingValues = (data) => {
  //   if (isEmpty(data)) return;
  //   const locationData = data[trailerType];
  //   const destuffingocationDetails = InquiryType.EXPORT ?
  //     locationData.originLocationDetails : locationData.destinationLocationDetails
  //     setStuffingTruckingAddress({
  //     city: destuffingocationDetails?.city,
  //     countryId: destuffingocationDetails?.countryId,
  //     address: destuffingocationDetails?.address,
  //     state: destuffingocationDetails?.state,
  //     pincode: destuffingocationDetails?.pincode,
  //     name: destuffingocationDetails?.name,
  //   });
  //   let countryId;
  //   if (trailerType === InquiryType.EXPORT) {
  //     form.setFieldsValue({
  //       pickupPort: locationData.emptyContainerLocationPortDetails ? {
  //         key: JSON.stringify(locationData.emptyContainerLocationPortDetails || '{}'),
  //         label: `${locationData.emptyContainerLocationPortDetails?.name}
  //         [${locationData.emptyContainerLocationPortDetails?.code}]`,
  //       } : undefined,
  //       dropOffPort: locationData.destinationPortDetails ? {
  //         key: JSON.stringify(locationData.destinationPortDetails || '{}'),
  //         label: `${locationData.destinationPortDetails?.name} [${locationData.destinationPortDetails?.code}]`,
  //       } : undefined,
  //       stuffingAddress: locationData.originLocationDetails ? {
  //         key: locationData.originLocationDetails?.id,
  //         label: `${locationData.originLocationDetails?.name} (${locationData.originLocationDetails?.referenceNumber})`,
  //       } : undefined,
  //       cargoType: locationData.cargoType,
  //       product: locationData.productType,
  //     });
  //     countryId = getCountryId(
  //       [
  //         locationData.emptyContainerLocationPortDetails,
  //         locationData.destinationPortDetails,
  //         locationData.originLocationDetails,
  //       ],
  //     );
  //   } else {
  //     form.setFieldsValue({
  //       cfsLocation: locationData.originLocationDetails ? {
  //         key: locationData.originLocationDetails?.id,
  //         label: `${locationData.originLocationDetails?.name} (${locationData.originLocationDetails?.referenceNumber})`,
  //       } : undefined,
  //       dropOffPort: locationData.emptyContainerLocationPortDetails ? {
  //         key: JSON.stringify(locationData.emptyContainerLocationPortDetails || '{}'),
  //         label: `${locationData.emptyContainerLocationPortDetails?.name}
  //         [${locationData.emptyContainerLocationPortDetails?.code}]`,
  //       } : undefined,
  //       deStuffingAddress: locationData.destinationLocationDetails ? {
  //         key: locationData.destinationLocationDetails?.id,
  //         label: `${locationData.destinationLocationDetails?.name} (${locationData.destinationLocationDetails.referenceNumber})`,
  //       } : undefined,
  //       cargoType: locationData.cargoType,
  //     },
  //     () => {
  //       setFieldsValue({
  //         product: locationData.productType,
  //       })
  //     });
  //     countryId = getCountryId(
  //       [
  //         locationData.originLocationDetails,
  //         locationData.emptyContainerLocationPortDetails,
  //         locationData.destinationLocationDetails,
  //       ]
  //     );
  //   }
  //   setState({
  //     countrySelected: countryId,
  //     cfsLocation: trailerType === InquiryType.IMPORT ? locationData.originLocationDetails : cfsLocation,
  //     vehicleDetails: locationData?.containerDetails || [{ }],
  //   });
  //   setContainerDropOffCheck(locationData.emptyContainerLocationPortDetails?.code,
  //     locationData.destinationPortDetails?.code);
  // }

  const getInitialVehicleDetails = (index, key) => {
    if ((isValidArray(vehicleDetails) && vehicleDetails[index])) {
      return getPropertyValue(vehicleDetails[index], key);
    }
    return undefined;
  };

  const getProductOptions = () => {
    const cargoTypeSelected = getFieldValue('cargoType');
    
    if (productTypes?.[cargoTypeSelected]) {
      return productTypes[cargoTypeSelected].map((item) => (
        <Option key={item} value={item} data-value={item}>
          {item}
       </Option>
      ));
    }
    
    return null;
  };

  const renderAddressCard = (item, ind, showLabel = true) => {
    return (
      <>
        <div style={{ display: 'flex', lineHeight: '10px', justifyContent: 'space-between' }}>
          <span style={{ fontSize: `${tokens.fontSize.body}px`, margin: '8px 0 8px', fontWeight: 600 }}>
            {`${item.name} (${item.referenceNumber})`}
          </span>
          {showLabel && <span className={classes.locationType}
          style={{
            backgroundColor: LocationPreferences[item.location] === LocationPreferences.CFS
              ? '#F0EBFF' : '#FFFBD0',
            borderColor: LocationPreferences[item.location] === LocationPreferences.CFS
              ? '#AE90FF' : '#FFC83C',
          }}>{LocationPreferences[item.location]}</span>}
        </div>
        {renderAddressDetails({
          item,
          orgMaster,
          classes,
        })}
      </>
    );
  };

  const getFilterVehicleTypesSize = (labelValue, cargoType) => {
    const filteredList: any = [];
    domesticVehicleTypeSizeList.filter((container) => {
      if (!filteredList?.some((item) => item?.key[labelValue] === container?.key[labelValue])) {
        if (container?.canUse && container?.cargoList.includes(cargoType)) {
          filteredList.push(container);
        }
      }
    });
    return filteredList;
  };

  // --- Product-Vehicle Containerisation Logic (mirrors FCL's product-container logic) ---

  const getVehicleAndQuantityDetails = (containerAndQuantityDetails: any[]): any[] => {
    if (!Array.isArray(containerAndQuantityDetails)) return [];
    const vehicleTypeKeys = Object.keys(masterVehicleTypes)
    return containerAndQuantityDetails.filter(
      (detail) => vehicleTypeKeys.includes(detail?.containerType)
    );
  };

  const isProductVehicleRuleMatch = (givenRuleSet: ProductVehicleRuleSet): boolean => {
    const { productVehicleRuleSet } = state;
    if (!productVehicleRuleSet) return true;
    return Object.keys(givenRuleSet).every(
      (key) => productVehicleRuleSet[key] === givenRuleSet[key]
    );
  };

  // Vehicle rows only support weight units (kg/mt/lbs). A product may use a
  // volume/count unit (units, cbm, barrel, ...) that has no vehicle-level
  // equivalent — fold those to 'kg' (1:1) so the product still maps to its
  // vehicle row and the containerisation totals are computed.
  const vehicleValidUnits = (weightsUnits || [])
    .filter((u) => !EXCLUDED_WEIGHT_UNITS.includes(u))
    .map((u) => u.toLowerCase());
  const normalizeToVehicleUnit = (unit: string): string =>
    vehicleValidUnits.includes(unit) ? unit : 'kg';

  const calculateVehicleDetails = (): Record<string, { totalVehicleCount: number; totalVehicleWeight: number }> => {
    const { productDetails, productDetailList } = state;

    return Object.keys(productDetails).reduce((acc, key) => {
      const productDetail = productDetails[key];
      const fullProductData = productDetailList.find((p) => p.key === productDetail?.key);
      const allContainerDetails =
        fullProductData?.containerAndQuantityDetails ||
        productDetail?.containerAndQuantityDetails || [];
      const vehicleQtyDetails = getVehicleAndQuantityDetails(allContainerDetails);

      if (!productDetail || !productDetail.key || vehicleQtyDetails.length === 0) {
        return acc;
      }

      const givenProductQuantity = Number(form.getFieldValue(`productQuantity${key}`)) || Number(productDetail?.quantity) || 0;
      const productUnit = (form.getFieldValue(`productUnit${key}`) || productDetail?.unit || '').toLowerCase();
      const totalQuantityForVehicle = vehicleQtyDetails.find(
        (detail) =>
          detail.containerType === productDetail?.productCnType &&
          detail.containerSize === productDetail?.productCnSize
      )?.totalQuantity;

      const mapKey = `${productDetail?.productCnType?.trim()}_${productDetail?.productCnSize?.trim()}_${normalizeToVehicleUnit(productUnit)}`;

      if (!acc[mapKey]) {
        acc[mapKey] = { totalVehicleCount: 0, totalVehicleWeight: 0 };
      }

      if (givenProductQuantity > 0) {
        acc[mapKey].totalVehicleWeight += givenProductQuantity;
      }

      if (totalQuantityForVehicle > 0) {
        acc[mapKey].totalVehicleCount += givenProductQuantity / totalQuantityForVehicle;
      }

      return acc;
    }, {} as Record<string, { totalVehicleWeight: number; totalVehicleCount: number }>);
  };

  const debouncedApplyCalculatedVehicleDetails = debounce(() => {
    applyCalculatedVehicleDetails();
  }, 300);

  const applyCalculatedVehicleDetails = () => {
    if (!inquiryFormPrefill || isRPTL) return;
    const mode = getMode();
    if (mode !== InquiryModes.DOMESTIC) return;

    const vehicleTotalsMap = calculateVehicleDetails();
    const updates: any = {};
    const currentVehicleList = form.getFieldValue('vehicleDetails') || state.vehicleDetails;

    currentVehicleList.forEach((_item: any, index: number) => {
      const vehicleTypeValue = form.getFieldValue(`vehicleDetails[${index}].type`);
      const vehicleSizeValue = form.getFieldValue(`vehicleDetails[${index}].size`);

      if (!vehicleTypeValue || !vehicleSizeValue) return;

      const matchingLabel = domesticVehicleTypeSizeList?.find((vt) => vt?.key?.type === vehicleTypeValue)?.label?.type;
      const vehicleTypeDbKey = Object.entries(masterVehicleTypes).find(([, label]) => label === matchingLabel)?.[0] || vehicleTypeValue;
      const vehicleWeightUnit = (form.getFieldValue(`vehicleDetails[${index}].weight.unit`) || '').toLowerCase();
      const mapKey = `${vehicleTypeDbKey?.trim()}_${vehicleSizeValue?.trim()}_${normalizeToVehicleUnit(vehicleWeightUnit)}`;
      const countField = `vehicleDetails[${index}].count`;
      const weightField = `vehicleDetails[${index}].weight.value`;
      const currentCountVal = form.getFieldValue(countField);
      const currentWeightVal = form.getFieldValue(weightField);

      if (!vehicleTotalsMap[mapKey]) {
        updates[weightField] = undefined;
        updates[countField] = 1;
        return;
      }

      const { totalVehicleCount, totalVehicleWeight } = vehicleTotalsMap[mapKey];
      const newCount = Math.max(1, Math.ceil(totalVehicleCount));
      const newWeight = Number(totalVehicleWeight) || undefined;

      if (currentCountVal !== newCount) updates[countField] = newCount;
      if (currentWeightVal !== newWeight) updates[weightField] = newWeight;
    });

    if (Object.keys(updates).length > 0) {
      form.setFieldsValue(updates);
    }

    const productKeys = Object.keys(state.productDetails || {});
    if (productKeys.length > 0) {
      const productCnTypeFields = productKeys.map((k) => `productCnType${k}`);
      const productCnSizeFields = productKeys.map((k) => `productCnSize${k}`);
      form.validateFields([...productCnTypeFields, ...productCnSizeFields], { force: true });
    }
  };

  const resetProductAndVehicleDetailFields = () => {
    if (!inquiryFormPrefill || isRPTL || !state.productVehicleRuleSet) return;

    const { productDetails } = state;
    const cargoType = form.getFieldValue('cargoType');
    const vehicleTypesFiltered = getFilterVehicleTypesSize('type', cargoType);
    const vehicleSizesFiltered = getFilterVehicleTypesSize('size', cargoType);
    const defaultType = vehicleTypesFiltered?.length ? vehicleTypesFiltered[0]?.key?.type : 'STANDARD_TRAILER';
    const defaultSize = defaultDomesticVehicleSize || (vehicleSizesFiltered?.length ? vehicleSizesFiltered[0]?.key?.size : "20'");

    Object.keys(productDetails).forEach((key) => {
      form.setFieldsValue({
        [`productKey${key}`]: undefined,
        [`productQuantity${key}`]: undefined,
        [`productUnit${key}`]: undefined,
        [`productCnType${key}`]: undefined,
        [`productCnSize${key}`]: undefined,
      });
    });

    const currentVehicleList = form.getFieldValue('vehicleDetails') || state.vehicleDetails;
    currentVehicleList.forEach((_item: any, index: number) => {
      form.setFieldsValue({
        [`vehicleDetails[${index}].count`]: undefined,
        [`vehicleDetails[${index}].type`]: defaultType,
        [`vehicleDetails[${index}].size`]: defaultSize,
        [`vehicleDetails[${index}].weight.value`]: undefined,
      });
    });

    setState({
      productDetails: {
        0: { key: '', quantity: 0, unit: '', productCnType: '', productCnSize: '', containerAndQuantityDetails: [] },
      },
      vehicleDetails: [{}],
      productVehicleRuleSet: null,
    });
  };

  const handleProductChangeForDomestic = (key: string, val: any) => {
    const { productDetails, productDetailList, productVehicleRuleSet } = state;
    const mode = getMode();

    if (mode !== InquiryModes.DOMESTIC || !inquiryFormPrefill || isRPTL) {
      setState({
        productDetails: {
          ...productDetails,
          [key]: {
            ...productDetails[key],
            key: typeof val === 'string' ? val : val?.key,
            name: typeof val === 'string' ? undefined : val?.value,
            referenceNumber: typeof val === 'string' ? undefined : val?.referenceNumber,
          },
        },
      });
      return;
    }

    if (val === undefined) {
      form.resetFields([
        `productKey${key}`, `productQuantity${key}`, `productUnit${key}`,
        `productCnType${key}`, `productCnSize${key}`,
      ]);
      setState({
        productDetails: {
          ...productDetails,
          [key]: { key: '', quantity: 0, unit: '', productCnType: '', productCnSize: '', containerAndQuantityDetails: [] },
        },
      }, () => { applyCalculatedVehicleDetails(); });
      return;
    }

    const currentError = form.getFieldError(`productKey${key}`);
    if (currentError && currentError.length) {
      form.resetFields([`productKey${key}`]);
    }

    const selected = productDetailList.find((item) => item?.key === val?.key);
    const vehicleQtyDetails = getVehicleAndQuantityDetails(selected?.containerAndQuantityDetails || []);
    const selectedVehicleType = vehicleQtyDetails?.[0]?.containerType || undefined;
    const selectedVehicleSize = vehicleQtyDetails?.[0]?.containerSize || undefined;
    const selectedWeightUnit = vehicleQtyDetails?.[0]?.totalQuantityUnit || undefined;
    const selectedCargoType = selected?.cargoType || CargoTypes.General;
    const selectedProductType = selected?.cargoProductType || DEFAULT_PRODUCT_TYPE;

    const nextProductDetails = {
      ...productDetails,
      [key]: {
        ...productDetails[key],
        key: typeof val === 'string' ? val : val?.key,
        name: typeof val === 'string' ? undefined : val?.value,
        referenceNumber: typeof val === 'string' ? undefined : val?.referenceNumber,
        unit: selectedWeightUnit,
        productCnType: selectedVehicleType,
        productCnSize: selectedVehicleSize,
        containerAndQuantityDetails: vehicleQtyDetails,
      },
    };

    const selectedProducts = Object.values(nextProductDetails).filter((p: any) => p?.key);
    const isFirstSelection = selectedProducts.length === 1;

    if (!productVehicleRuleSet || isFirstSelection) {
      const formValues: any = {
        cargoType: selectedCargoType,
        product: selectedProductType,
        [`productCnType${key}`]: selectedVehicleType,
        [`productCnSize${key}`]: selectedVehicleSize,
        [`productUnit${key}`]: selectedWeightUnit,
        [`productQuantity${key}`]: undefined,
      };

      const currentVehicleList = form.getFieldValue('vehicleDetails') || state.vehicleDetails;
      // Convert product DB key (STANDARD_TRAILER) to domesticVehicleTypeSizeList key format (STANDARD TRAILER)
      const vehicleTypeForForm = domesticVehicleTypeSizeList?.find(
        (vt) => vt?.label?.type === masterVehicleTypes[selectedVehicleType]
      )?.key?.type || selectedVehicleType;
      // Only auto-set vehicle rows that don't already have a type selected (or on first product selection)
      currentVehicleList.forEach((_item: any, index: number) => {
        const existingType = form.getFieldValue(`vehicleDetails[${index}].type`);
        if (isFirstSelection || !existingType) {
          formValues[`vehicleDetails[${index}].type`] = vehicleTypeForForm;
          formValues[`vehicleDetails[${index}].size`] = selectedVehicleSize;
        }
        formValues[`vehicleDetails[${index}].count`] = undefined;
        formValues[`vehicleDetails[${index}].weight.value`] = undefined;
      });

      form.setFieldsValue(formValues);
      setState({
        productDetails: nextProductDetails,
        productVehicleRuleSet: {
          cargoType: selectedCargoType,
          cargoProductType: selectedProductType,
        },
      });
      return;
    }

    if (!isProductVehicleRuleMatch({
      cargoType: selectedCargoType,
      cargoProductType: selectedProductType,
    })) {
      form.setFields({
        [`productKey${key}`]: {
          value: undefined,
          errors: [new Error(`Selected product has cargo type "${selectedCargoType}" and product type "${selectedProductType}" which does not match the existing products. All products must share the same cargo type and product type.`)],
        },
      });
      form.resetFields([`productQuantity${key}`, `productUnit${key}`, `productCnType${key}`, `productCnSize${key}`]);
      setState({
        productDetails: {
          ...productDetails,
          [key]: { key: '', quantity: 0, unit: '', productCnType: '', productCnSize: '', containerAndQuantityDetails: [] },
        },
      }, () => { applyCalculatedVehicleDetails(); });
      return;
    }

    setState({ productDetails: nextProductDetails });
    form.setFieldsValue({
      cargoType: selectedCargoType,
      product: selectedProductType,
      [`productCnType${key}`]: selectedVehicleType,
      [`productCnSize${key}`]: selectedVehicleSize,
      [`productUnit${key}`]: selectedWeightUnit,
      [`productQuantity${key}`]: undefined,
    });
  };

  // --- End Product-Vehicle Containerisation Logic ---

  const renderCargoReadyOrClosingTime = (title, fieldLabel, initialValue?, isRequired = true) => {
    return (
      <div
        className={parentClasses.rowDiv}
        style={{
          marginBottom: '10px',
          verticalAlign: 'middle',
        }}
      >
        <div
          style={{
            width: '25%',
            flexShrink: 0,
            marginRight: '8px',
            whiteSpace: fieldLabel === 'cargoDate' ? 'nowrap' : 'break-spaces',
            marginTop: '10px',
            lineHeight: '16px',
          }}
        >
          <span className={parentClasses.formTitles} style={{ lineHeight: '16px' }}>{title}{isRequired ? <Asterisk/> : ''}</span>
        </div>
        <div style={{ flex: 1 }}>
          <FormItem style={{ width: '50%', marginBottom: 0 }}>
            {getFieldDecorator(fieldLabel, {
              rules: [{ required: isRequired, message: 'Required' }],
              initialValue,
            })(
              <DatePicker
                showTime={fieldLabel !== 'cargoDate' && {
                  defaultValue: moment('23:59', 'HH:mm'),
                }}
                disabledDate={fieldLabel !== 'cargoDate' ? disableInquiryClosingDate : undefined}
                disabledTime={fieldLabel !== 'cargoDate' ? disableInquiryClosingTimeUtil : undefined}
                allowClear
                disabled={isPrefilling}
                style={{ width: '100%' }}
                format={fieldLabel === 'cargoDate' ? 'DD MMM YYYY' : 'DD MMM YYYY | HH:mm'}
                placeholder={fieldLabel === 'cargoDate' ? 'Cargo Ready Date' : 'Inquiry Closing Time'}
              />
            )}
          </FormItem>
        </div>
      </div>
    );
  };

  const isProductMandatory = () => {
    const isDraft = getFieldValue('isDraft');
    const isRequired = (isDraft && draftMandatoryFields?.includes('productId')) || !isDraft;
    
    return isRequired;
  };

  const renderCargoDetails = () => {
    let product = getFieldValue('product');
    const productObj = cargoList.find((cargo) => cargo.label.product === product);
    product = productObj?.key?.product;
    const showProductTempField = isTemperatureControlledMandatory && getFieldValue('cargoType') === CargoType.REEFER;
    const isDraft = getFieldValue('isDraft');
    const isRequired = (isDraft && draftMandatoryFields?.includes('cargoType')) || !isDraft;
    const isProductRequired = (isDraft && draftMandatoryFields?.includes('productType')) || !isDraft;
    
    const handleCargoChange = (cargo) => {
      const { setFieldsValue, getFieldValue } = form;

      if (getFieldValue('cargoType') === cargo.toUpperCase()) return;

      setFieldsValue({
        cargoType: cargo.toUpperCase(),
        product: undefined,
      });

      resetProductAndVehicleDetailFields();
    };

    const getCargoType = () => form.getFieldValue('cargoType');
    
    return (
      <Row
        gutter={[0, 24]}
        style={{
          marginBottom: '0px',
          marginRight: '10px',
          verticalAlign: 'middle',
        }}
      >
        <Col id="grid#cargoAndProduct" className={parentClasses.rowDiv}>
          <span
            className={classNames(parentClasses.formTitles, parentClasses.gridLabelWidth)}
            style={{ width: '12.5%', marginRight: '6px' }}
          >
            Cargo & Product{isRequired ? <Asterisk /> : ''}
          </span>
          <div className={classNames(parentClasses.rowDiv, parentClasses.gridInputFieldWidth)}>
            <FormItem
              style={{ width: '18%', marginBottom: 0 }}
              className={classes.formItemSmallError}
            >
              {getFieldDecorator('cargoType', {
                initialValue: isRequired ? 'GENERAL' : undefined,
                rules: [{ required: isRequired, message: 'Cargo type is required' }],
                trigger: undefined,
              })(
                <Select
                  disabled={isBooking || isPrefilling}
                  showSearch
                  placeholder="Cargo Type"
                  optionLabelProp={'data-value'}
                  onChange={(cargo: any) => {
                    handleCargoChange(cargo);
                  }}
                >
                  {cargoTypes?.map((item) => {
                    return (
                      <Option key={item.key} value={item.key} data-value={item.label}>
                        {item.label}
                      </Option>
                    );
                  })}
                </Select>
              )}
            </FormItem>
            <FormItem
              className={classes.formItemSmallError}
              style={{
                marginLeft: '6px',
                width: '32%',
                marginBottom: 0,
              }}
            >
              {getFieldDecorator('product', {
                initialValue: isProductRequired ? 'General Dry Goods' : undefined,
                rules: [{ required: isProductRequired }],
              })(
                <Select
                  disabled={isBooking || isPrefilling}
                  showSearch
                  placeholder="Select Product"
                  style={{ width: '100%' }}
                  optionLabelProp={'data-value'}
                  dropdownMatchSelectWidth={false}
                  notFoundContent={!getCargoType() && 'Please Select Cargo Type'}
                  onChange={() => {
                    resetProductAndVehicleDetailFields();
                  }}
                >
                  {getProductOptions()}
                </Select>
              )}
            </FormItem>
            {showProductTempField && (
              <React.Fragment>
                <Form.Item
                  className={classes.formItemSmallError}
                  style={{ marginLeft: '6px', width: '18%', marginBottom: 0 }}
                >
                  {getFieldDecorator('temperatureControlled', {
                    rules: [
                      {
                        validator: (rule, value, cb) =>
                          productTempValidation(rule, value, cb, reeferProductTempRange, product),
                      },
                    ],
                  })(
                    <InputNumber
                      type="number"
                      style={{ width: '100%' }}
                      precision={2}
                      placeholder="0"
                    />
                  )}
                </Form.Item>
                <span style={{ margin: '8px 0 0 8px' }}>
                  °<span style={{ fontWeight: 600 }}>C</span>
                </span>
              </React.Fragment>
            )}
          </div>
        </Col>
      </Row>
    );
  };

  const renderReferenceRate = () => {
    const { orgCurrency } = props;
    return (
      <div className={parentClasses.rowDiv} style={{ alignItems: 'center' }}>
        <div style={{ width: '25%' }}>
          <span className={parentClasses.formTitles}>Overall Reference Rate </span>
        </div>
        <div style={{ width: '75%', display: 'flex', alignItems: 'center' }}>
          <FormItem style={{ marginBottom: '0px', width: '28%' }}>
            {getFieldDecorator("referenceRate.amount")(
              <InputNumber
                style={{ width: '100%' }}
                placeholder="Rate"
                disabled={isBooking || isPrefilling} />
            )}
          </FormItem>
          <FormItem style={{ marginBottom: '0px', width: '25%', marginLeft: '2px' }}>
            {getFieldDecorator("referenceRate.currency", {
              initialValue: orgCurrency,
            })(
              <Select
                style={{ width: '100%' }}
                dropdownMatchSelectWidth={false}
                disabled={isBooking || isPrefilling}
              >
                {currencies &&
                  Object.keys(currencies).map((item) => (
                    <Select.Option key={item}>{item}</Select.Option>
                  ))}
              </Select>
            )}
          </FormItem>
          {/* <span style={{ fontStyle: 'italic', fontSize: `${tokens.fontSize.small}px`, color: '#262626', marginLeft: '6px' }}>
            Per Trailer
          </span> */}
        </div>
      </div>
    );
  };

  const renderInternalReferenceNumber = () => {
    return (
      <div className={parentClasses.rowDiv}>
                <div style={{ width: '25%', marginTop: '0px' }}>
                  <span className={parentClasses.formTitles}>Internal Reference No. </span>
                </div>
                <FormItem style={{ marginBottom: '15px', width: '75%' }}>
                  {getFieldDecorator('internalReference')(
                    <Input
                      style={{ width: '70%' }}
                      placeholder="Internal Reference Number"
                      disabled={isBooking || isPrefilling}
                    />
                  )}
                </FormItem>
      </div>
    );
  }

  const renderBusinessType = () => {
    const {
      masterData: { businessTypeList },
    } = props;
    const businessTypes: string[] = businessTypeList ? Object.values(businessTypeList) : [];
    return (
      <div className={parentClasses.rowDiv}>
        <div style={{ width: '25%', marginTop: '10px' }}>
          <span className={parentClasses.formTitles}>Business Type </span>
        </div>
        <FormItem style={{ width: '75%'}}>
          {getFieldDecorator("businessType", {})(
            <Select style={{ width: '70%' }} disabled={isBooking || isPrefilling} allowClear placeholder={'Business Type'}>
              {businessTypes.length && businessTypes.map((value: string) => (
                <Select.Option key={value} data-value={value}>{value}</Select.Option>
              ))}
            </Select>
          )}
        </FormItem>
      </div>
    );
  }

  const renderBusinessEntity = () => {
    const {
      businessEntities
    } = props;

    if (!businessEntities){
      return null;
    }

    return (
      <div className={parentClasses.rowDiv}>
        <div style={{ width: '25%', marginTop: '10px' }}>
          <span className={parentClasses.formTitles}>Business Entity </span>
        </div>
        <FormItem style={{ width: '75%'}}>
          {getFieldDecorator("businessEntity", {})(
            <Select style={{ width: '70%' }} disabled={isBooking || isPrefilling} allowClear placeholder={'Business Entity'}>
              {businessEntities?.length && businessEntities.map((value: string) => (
                <Select.Option key={value} data-value={value}>{value}</Select.Option>
              ))}
            </Select>
          )}
        </FormItem>
      </div>
    );
  }

  const renderCustomRadio = (name, key, isMandatory=false, initialValue=undefined) => {
    return (
      <div className={parentClasses.rowDiv}>
        <div style={{ width: '25%', marginTop: '10px' }}>
          <span className={parentClasses.formTitles}>
            {name}{isMandatory ? <Asterisk/> : ''}
          </span>
        </div>
        <FormItem style={{ width: '75%'}}>
          {getFieldDecorator(`${key}`, {
            rules: [{ required: isMandatory, message: 'Required' }],
            initialValue,
          })(
            <RadioGroup style={{ width: '70%' }} disabled={isBooking || isPrefilling}>
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </RadioGroup>
          )}
        </FormItem>
      </div>
    );
  }

  const renderCustomTextField = (name, key, isMandatory=false, initialValue=undefined) => {
    return (
      <div className={parentClasses.rowDiv}>
        <div style={{ width: '25%', marginTop: '10px' }}>
          <span className={parentClasses.formTitles}>
            {name}{isMandatory ? <Asterisk/> : ''}
          </span>
        </div>
        <FormItem style={{ width: '75%'}}>
          {getFieldDecorator(`${key}`, {
            rules: [{ required: isMandatory, message: 'Required' }],
            initialValue,
          })(
            <Input style={{ width: '70%' }} disabled={isBooking || isPrefilling} placeholder={name}/>
          )}
        </FormItem>
      </div>
    );
  }

  const renderCustomDropDown = (name, key, values, isMandatory=false, initialValue=undefined) => {
    return (
      <div className={parentClasses.rowDiv}>
        <div style={{ width: '25%', marginTop: '10px' }}>
          <span className={parentClasses.formTitles}>
            {name}{isMandatory ? <Asterisk/> : ''}
          </span>
        </div>
        <FormItem style={{ width: '75%'}}>
          {getFieldDecorator(`${key}`, {
            rules: [{ required: isMandatory, message: 'Required' }],
            initialValue,
          })(
            <Select style={{ width: '70%' }} disabled={isBooking || isPrefilling} allowClear placeholder={name}>
              {values.length && values.map((value: string) => (
                <Select.Option key={value} data-value={value}>{value}</Select.Option>
              ))}
            </Select>
          )}
        </FormItem>
      </div>
    );
  }

  const renderTermsAndConditions = () => {
    const vehicleList = form.getFieldValue('vehicleDetails');
    const vehicleType: string | undefined = vehicleList?.length ? vehicleList[0].type : undefined;
    let initialTnC = termsAndConditions;
    if (vehicleType && defaultVehicleSpecificTnC && InquiryModes.DOMESTIC in defaultVehicleSpecificTnC) {
      initialTnC = defaultVehicleSpecificTnC?.[InquiryModes.DOMESTIC]?.[vehicleType] ?? initialTnC;
    }

    return (<div className={parentClasses.rowDiv}>
      <div style={{ width: '25%', marginTop: '10px' }}>
        <span className={parentClasses.formTitles}>Terms &amp; Conditions </span>
      </div>
      <FormItem style={{ width: '75%' }}>
        {getFieldDecorator('terms', {
          initialValue: prefilledTermsAndConditions || initialTnC,
        })(
          <Input.TextArea
            placeholder={termsConditionsPlaceholder}
            style={{ width: '70%', height: '70px' }}
            autoComplete="new-password"
            disabled={isBooking || isPrefilling}
          />
        )}
      </FormItem>
    </div>);
  };

  const renderOtherDetails = () => {
    return (<div className={parentClasses.rowDiv}>
      <div style={{ width: '25%', marginTop: '10px' }}>
        <span className={parentClasses.formTitles}>Other Details </span>
      </div>
      <FormItem style={{ width: '75%' }}>
        {getFieldDecorator('extraDetails', {})(
          <Input.TextArea
            placeholder={'Add other details related to inquiry'}
            style={{ width: '70%', height: '70px' }}
            autoComplete="new-password"
            maxLength={1000}
            disabled={isBooking || isPrefilling}
          />
        )}
      </FormItem>
    </div>);
  };

  const handleRemoveVehicle = (index) => {
    const newList = form.getFieldValue('vehicleDetails');
    newList.splice(index, 1);
    setState({ vehicleDetails: newList }, () => { applyCalculatedVehicleDetails(); });
    form.setFieldsValue({
      vehicleDetails: newList,
    });
  };

  const renderVehicleDetails = () => {
    const cargoType = getFieldValue('cargoType');
    const vehicleTypes = getFilterVehicleTypesSize('type', cargoType);
    const vehicleSizes = getFilterVehicleTypesSize('size', cargoType);
    const initialVehicleTypeValue = vehicleTypes?.length ? vehicleTypes[0]?.key?.type : "STANDARD TRAILER";
    const initialVehicleSizeValue = defaultDomesticVehicleSize ? defaultDomesticVehicleSize : vehicleSizes?.length ? vehicleSizes[0]?.key?.size : "20'";
    let initialWeight = {};
    if (cargoType && defaultCargoSpecificGrossWeight) {
      initialWeight = defaultCargoSpecificGrossWeight?.[cargoType] ?? {};
    }
    const isDraft = getFieldValue('isDraft');
    const isRequired = (isDraft && draftMandatoryFields?.includes('containerDetails')) || !isDraft;
    const isEditOrBooking = !!isEdit || !!isBooking;
    
    return (
      <Row
        gutter={24}
        style={{
          marginBottom: '25px',
          marginRight: '10px',
          verticalAlign: 'middle',
        }}
      >
        <Col span={3} style={{ marginTop: '5px' }}>
          <span className={parentClasses.formTitles}> Vehicle details{isRequired ? <Asterisk /> : ''} </span>{' '}
        </Col>
        <Col span={21}>

        <div style={{paddingLeft: 16}}>
        <Row gutter={12} key={'header'}>
                <Col span={3}>
                  Count
                </Col>
                <Col span={5} style={{ paddingLeft: 0, paddingRight: 0 }}>
                  Type
                </Col>
                <Col span={4}>
                  Size
                </Col>
                <Col span={1}></Col>
                <Col span={4}>
                  Gross Weight
                </Col>
                <Col span={3}>
                  Unit
                </Col>
              </Row>

          {vehicleDetails?.map((item, index) => {
            return (
              <Row gutter={12} key={index}>
                <Col span={3}>
                  <FormItem style={{ marginBottom: '0px' }}>
                    {getFieldDecorator(`vehicleDetails[${index}].count`, {
                      rules: [{ required: isRequired, message: 'Required' }],
                      initialValue: isEditOrBooking ? prefilledVehicleDetails?.[index]?.count 
                        : (getInitialVehicleDetails(index, 'count') || isRequired ? 1 : undefined),
                    })(
                    <InputNumber
                      placeholder='Count'
                      style={{ width: '100%' }}
                      min={1}
                      precision={0}
                      disabled={isPrefilling}
                    />)}
                  </FormItem>
                </Col>
                <Col span={5} style={{ paddingLeft: 0, paddingRight: 0 }}>
                  <FormItem style={{ marginBottom: '0px' }}>
                    {getFieldDecorator(`vehicleDetails[${index}].type`, {
                      rules: [{ required: isRequired, message: 'Required' }],
                      initialValue: isEditOrBooking ? prefilledVehicleDetails?.[index]?.type
                        : (getInitialVehicleDetails(index, 'type') || isRequired ? initialVehicleTypeValue : undefined),
                    })(
                      <Select
                        placeholder="Type"
                        allowClear={false}
                        style={{ width: '100%' }}
                        disabled={isBooking || isPrefilling}
                        dropdownMatchSelectWidth={false}
                        optionLabelProp="data-value"
                        onChange={() => {
                          setTimeout(() => { applyCalculatedVehicleDetails(); }, 0);
                        }}
                      >
                        {vehicleTypes?.map((item) => (
                          <Option key={item?.key?.type} value={item?.key?.type} data-value={item?.label?.type}>
                            <Tooltip title={item?.label?.type}>
                              <span>{item?.label?.type}</span>
                            </Tooltip>
                          </Option>
                        ))}
                      </Select>
                    )}
                  </FormItem>
                </Col>
                <Col span={4}>
                  <FormItem style={{ marginBottom: '0px' }}>
                    {getFieldDecorator(`vehicleDetails[${index}].size`, {
                      rules: [{ required: isRequired, message: 'Required' }],
                      initialValue: isEditOrBooking ? prefilledVehicleDetails?.[index]?.size 
                        : (getInitialVehicleDetails(index, 'size') || isRequired ? initialVehicleSizeValue : undefined),
                    })(
                      <Select
                        placeholder="Size"
                        allowClear={false}
                        style={{ width: '100%' }}
                        disabled={isBooking || isPrefilling}
                        dropdownMatchSelectWidth={false}
                        onChange={() => {
                          setTimeout(() => { applyCalculatedVehicleDetails(); }, 0);
                        }}
                      >
                        {vehicleSizes?.map((item) => (
                          <Option key={item?.key?.size} data-value={item?.label?.size}>
                            {item?.label?.size}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </FormItem>
                </Col>
                <Col span={1}>
                  <div
                    style={{
                      margin: '5px 0px 0px 8px',
                      borderLeft: '1px solid #666666',
                      height: '30px',
                    }}
                  />
                </Col>
                <Col span={4}>
                  <FormItem style={{ marginBottom: '0px' }}>
                    {getFieldDecorator(`vehicleDetails[${index}].weight.value`, {
                      rules: [{ required: isRequired, message: 'Required' }],
                      initialValue: isEditOrBooking ? prefilledVehicleDetails?.[index]?.weight?.value 
                        : (getInitialVehicleDetails(index, 'weight.value') || isRequired ? initialWeight?.['value'] : undefined),
                    })(
                      <InputNumber
                        placeholder="Gross Wt"
                        disabled={isBooking || isPrefilling}
                        style={{ width: '100%'}}
                        min={1}
                      />
                    )}
                  </FormItem>
                </Col>
                <Col span={3}>
                  <FormItem style={{ marginBottom: '0px' }}>
                    {getFieldDecorator(`vehicleDetails[${index}].weight.unit`, {
                      rules: [{ required: isRequired, message: 'Required' }],
                      initialValue: isEditOrBooking ? prefilledVehicleDetails?.[index]?.weight?.unit 
                        : (getInitialVehicleDetails(index, 'weight.unit') || initialWeight?.['unit'] || 'kg'),
                    })(
                      <Select
                        placeholder="Type"
                        allowClear={false}
                        disabled={isBooking || isPrefilling}
                        style={{ width: '100%' }}
                        dropdownMatchSelectWidth={false}
                        onChange={() => {
                          setTimeout(() => { applyCalculatedVehicleDetails(); }, 0);
                        }}
                      >
                        {weightsUnits?.map((unit) => {
                          // Skipping "cases" unit as it is required only in containerUnits
                          if (EXCLUDED_WEIGHT_UNITS.includes(unit)) {
                            return null;
                          } else {
                            return (
                              <Option key={unit}>{unit}</Option>
                            );
                          }
                        })}
                      </Select>
                    )}
                  </FormItem>
                </Col>
                <Col span={1}>
                  {(!isBooking &&
                    vehicleDetails?.length > 1 ) && <Icon type="close"
                    style={{ color: 'red', marginTop: '12px' }}
                    onClick={() => handleRemoveVehicle(index)}
                  />}
                </Col>
              </Row>
            );
          })}
          {!isBooking && <Row>
            <Col style={{ paddingTop: '0', color: tokens.colors.primary }}>
              <Icon
                type="plus"
                style={{
                  height: '12px',
                  width: '12px',
                  margin: '4px 4px 0 0',
                }}
              />
              <a
                type="plus-circle"
                style={{
                  cursor: 'pointer',
                  fontSize: `${tokens.fontSize.small}px`,
                }}
                onClick={() => handleAddMore()}
              >
                Add More
              </a>
            </Col>
          </Row>}
        </div>
        </Col>
      </Row>
    );
  };

  const handleAddMore = () => {
    const newList = [
      ...vehicleDetails,
      {},
    ];
    setState({ vehicleDetails: newList }, () => { applyCalculatedVehicleDetails(); });
  };

  const getAddress = async (props) => {
    const {
      locationList,
      addressType,
      addressList
    } = props;

    setState({ isAddressLoading: true });
    const response = await fetchAddresses({
      locationList,
      addressType,
      shipperId: (isEdit || isBooking) ? shipperId : organisationId
      // countryIdList: countrySelected ? [countrySelected] : [],
    });
    
    
    const filteredAddresses = response.data?.filter((item) => { 
      if (addressList === 'stuffingAddresses'){
        return (!!item?.address);
      } else if (addressList === 'deStuffingAddresses'){
        return (!!item?.address);
      } else {
        return !!item?.address;
      }
    });
    if (response.isSuccess) {
      setState({
        [`${addressList}`]: filteredAddresses,
        isAddressLoading: false,
      })
    } else {
      message.error(response.errorMessage);
      setState({
        isAddressLoading: false,
      })
    }
  }

  const messageError = () => {
    message.error('Origin and destination address cannot be same');
    return;
  }

  async function handleAddressChange(option, isStuffing: boolean) {
    !form.getFieldValue('cfsLocation') &&
    !form.getFieldValue('dropOffPort') &&
    !form.getFieldValue('pickupPort') &&
    // setState({ countrySelected: option?.props?.countryId });
    isStuffing ? 
    (
      setStuffingTruckingAddress(option ? {
        city: option.props?.city,
        countryId: option.props?.countryId,
        address: option.props?.address,
        state: option.props?.state,
        pincode: option.props?.pincode,
        name: option.props?.name,
      } : undefined)
    ):
    (
      setDeStuffingTruckingAddress(option ? {
        city: option.props?.city,
        countryId: option.props?.countryId,
        address: option.props?.address,
        state: option.props?.state,
        pincode: option.props?.pincode,
        name: option.props?.name,
      } : undefined)
    );
  }

  const renderStuffingOrDeStuffingAddress = (fieldLabel: string, fieldArray, isStuffing: boolean, addressType: CargoOperationType, apiKey) => {
    const {
      enableAddressMasterInMenu,
      permissions
    } = props
    const isDraft = form.getFieldValue('isDraft');
    const isRequired = (isDraft && draftMandatoryFields?.includes(apiKey)) || !isDraft;
    const contactType = isStuffing ? 'origin' : 'destination';
    const phoneFieldName = `${contactType}InchargePhone`;
    const emailFieldName = `${contactType}InchargeEmail`;
    const nameFieldName = `${contactType}InchargeName`;
    const prefilledIncharge = isStuffing ? prefilledOriginIncharge : prefilledDestinationIncharge;
    
    return (
      <Timeline.Item dot={<div className={[classes.dot, classes.dotFilled].join(' ')}></div>} style={{padding: '0 0 10px 0'}}>
        <Row>
          <Col span={12}>
            <Row>
              <Col span={4} style={{ marginTop: '5px' }}>
                <span className={parentClasses.formTitles}>
                  {isStuffing ? 'Stuffing Location' : 'De-Stuffing Location'}{' '}{isRequired ? <Asterisk /> : ''}
                </span>{' '}
                <div className={classes.fontItalic}>{isStuffing ? '(Origin)' : '(Destination)'}</div>
              </Col>
              <Col span={20} style={{ paddingLeft: '16px' }}>
                <FormItem style={{ marginBottom: '8px', width: '70%' }}>
                  {getFieldDecorator(fieldLabel, {
                    rules: [
                      {
                        required: isRequired,
                        message: isStuffing
                          ? 'Stuffing Location Required'
                          : 'De-Stuffing Location Required',
                      },
                    ],
                  })(
                    <SelectAddress
                      placeholder={
                        isStuffing ? 'Select Stuffing Location' : 'Select De-Stuffing Location'
                      }
                      shipperId={(isEdit || isBooking) ? shipperId : organisationId}
                      cargoOperationType={addressType}
                      addresses={fieldArray}
                      allowEdit={
                        enableAddressMasterInMenu
                          ? hasMasterCategoryEditPermission('ADDRESS', permissions)
                          : true
                      }

                      detailed={true}
                      labelInValue = {true}
                      data-testid={isStuffing ? 'stuffingAddressDropdown' : 'deStuffingAddressDropdown'}
                      onChange={(item, option: any) => {
                        //stuffing and destuffing address should not be same
                        if (isStuffing){
                          const selectedDeStuffingAddressId = form.getFieldValue('deStuffingAddress');
                          if (String(selectedDeStuffingAddressId) === option?.props?.id) {
                            messageError();
                            setTimeout(() => {
                                setFieldsValue({ stuffingAddress: undefined });
                                setStuffingTruckingAddress(undefined);
                            }, 200);
                            return;
                          }
                        } else {
                          const selectedStuffingAddressId = form.getFieldValue('stuffingAddress');
                          if (String(selectedStuffingAddressId) === option?.props?.id) {
                            messageError();
                            setTimeout(() => {
                              setFieldsValue({ deStuffingAddress: undefined });
                              setDeStuffingTruckingAddress(undefined);
                            }, 200);
                            return;
                          }
                        }
                        handleAddressChange(option, isStuffing);
                        }}
                    >
                    </SelectAddress>
                  )}
                </FormItem>
                {renderAddressDetails({
                  classes,
                  orgMaster,
                  item: isStuffing ? stuffingAddressObj : deStuffingAddressObj,
                  style: { fontSize: `${tokens.fontSize.small}px`, width: '70%' },
                })}
              </Col>
            </Row>
          </Col>

          <Col span={12}>
            <div style={{ marginLeft: '80px' }}>
              <div className={parentClasses.rowDiv}>
                <div style={{ width: '25%', marginTop: '5px' }}>
                  <span className={parentClasses.formTitles}>Incharge Details</span>
                  <div className={classes.fontItalic}>{isStuffing ? '(Origin)' : '(Destination)'}</div>
                </div>
                <div style={{ width: '70%', display: 'flex', gap: '8px' }}>
                  <FormItem style={{ marginBottom: '8px', flex: 1 }}>
                    {getFieldDecorator(nameFieldName, {
                      initialValue: prefilledIncharge?.name,
                    })(
                      <Input
                        placeholder="Name"
                        disabled={isBooking || isPrefilling}
                      />
                    )}
                  </FormItem>
                  <FormItem style={{ marginBottom: '8px', flex: 1 }}>
                    {getFieldDecorator(phoneFieldName, {
                      initialValue: prefilledIncharge?.phone,
                      rules: [
                        {
                          pattern: /^[\d\s\-\+\(\)]+$/,
                          message: 'Please enter a valid phone number',
                        },
                      ],
                    })(
                      <Input
                        placeholder="Phone"
                        disabled={isBooking || isPrefilling}
                      />
                    )}
                  </FormItem>
                  <FormItem style={{ marginBottom: '8px', flex: 1 }}>
                    {getFieldDecorator(emailFieldName, {
                      initialValue: prefilledIncharge?.email,
                      rules: [
                        {
                          type: 'email',
                          message: 'Please enter a valid email address',
                        },
                      ],
                    })(
                      <Input
                        placeholder="Email"
                        disabled={isBooking || isPrefilling}
                      />
                    )}
                  </FormItem>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Timeline.Item>
    );
  };

  const renderAddStopButton = () => {
    const isButtonDisabled = stopLocationKeys?.length >= MAX_DOMESTIC_STOP_LOCATIONS;
    if (isBooking) return;
    const addStopMenu = (
      <Menu>
        {['Delivery', 'Pickup'].map((item, index) => (
          <Menu.Item
            onClick={() => {
              if (!isButtonDisabled) {
                setState({stopLocationData: [...stopLocationData, item]})
                updateStopLocationKeys({
                  stopLocationKeys:
                  stopLocationKeys?.length > 0
                  ? [...stopLocationKeys, stopLocationKeys[stopLocationKeys.length - 1] + 1]
                  : [0],
                });
              }
            }}
          >
            {item}
          </Menu.Item>
        ))}
      </Menu>
    );
    return (
      <Timeline.Item
        dot={<div className={classes.lineFilled}></div>}
        className={classes.noTimelineHeadPadding}
        style={{ padding: '0 0 10px 0' }}
      >
        <Row>
          <Col span={13}>
            <Row>
              <Col span={4} style={{ marginTop: '5px' }}></Col>
              <Col span={20} style={{ paddingLeft: '16px' }}>
                <Dropdown overlay={addStopMenu}>
                  <a
                    type="plus-circle"
                    style={{
                      cursor: 'pointer',
                      color: isButtonDisabled ? '#8c8c8c' : tokens.colors.primary,
                    }}
                    onClick={(e) => e.preventDefault()}
                  >
                    + Add Stop
                  </a>
                </Dropdown>
              </Col>
            </Row>
          </Col>
        </Row>
      </Timeline.Item>
    );
  };

  const renderStopsLocations = () => {
    const { 
      enableAddressMasterInMenu, 
      permissions 
    } = props;
  return (
    <>
      {stopLocationKeys?.map((stopIndex, index) => {
        const isPickup = stopLocationData[index] === 'Pickup';
        const selectOptions = isPickup ? stuffingAddresses : deStuffingAddresses;
        const addressType = isPickup ? CargoOperationType.STUFFING : CargoOperationType.DESTUFFING;
        const addressList = isPickup ? 'stuffingAddresses' : 'deStuffingAddresses';
        
        return (
          <Timeline.Item
            key={stopIndex}
            className={classes.noTimelineHeadPadding}
            dot={<div className={classes.dottedCircle}></div>}
            style={{ padding: '0 0 10px 0' }}
          >
            <Row>
              <Col span={13}>
                <Row>
                  <Col span={4}>
                    <span style={{ fontWeight: 600 }}>{`Stop ${index + 1}`}</span>
                    <span
                      className={`${classes.stopLocationTag} ${
                        classes[`stopLocationTag${stopLocationData[index]}`]
                      }`}
                    >
                      {stopLocationData[index]}
                    </span>
                  </Col>
                  <Col span={19} style={{ paddingLeft: '16px' }}>
                    <FormItem style={{ display: 'none' }}>
                      {getFieldDecorator(`stops[${stopIndex}].type`, {
                        rules: [{required: false}],
                        initialValue: stopLocationData[index],
                      })(<Input />)}
                    </FormItem>
                    <div style={{ width: '76%', display: 'flex', alignItems: 'center' }}>
                      <FormItem style={{ marginBottom: '0', width: '100%' }}>
                        {getFieldDecorator(`stops[${stopIndex}].address`, {
                          rules: [
                            {
                              required: true,
                              message: 'Stop cannot be empty',
                            },
                          ],
                        })(
                          <SelectAddress
                            data-testid={`stopLocationInput${index}`}
                            placeholder={'Select Stop'}
                            shipperId={(isEdit || isBooking) ? shipperId : organisationId}
                            cargoOperationType={addressType}
                            addresses={selectOptions}
                            allowEdit={
                              enableAddressMasterInMenu
                                ? hasMasterCategoryEditPermission('ADDRESS', permissions)
                                : true
                            }

                            detailed={true}
                            labelInValue={true}
                            disabled={isBooking || isPrefilling}
                          />
                        )}
                      </FormItem>
                      {!isBooking ? (
                        <Icon
                          type="close"
                          style={{ color: 'red', marginLeft: '8px' }}
                          onClick={() => {
                            stopLocationData.splice(index, 1);
                            setState({ stopLocationData: [...stopLocationData] });
                            updateStopLocationKeys({
                              stopLocationKeys: stopLocationKeys.filter((item) => item !== stopIndex),
                            });
                          }}
                        />
                      ) : null}
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Timeline.Item>
        );
      })}
    </>
  );
};

  const getDistance = async () => {
    const stuffingAddress = form.getFieldValue('stuffingAddress');
    const destuffingAddress = form.getFieldValue('deStuffingAddress');
    if (!stuffingAddress || !destuffingAddress){
      message.error('Please select stuffing and de-stuffing locations');
      return;
    }
    const stops = form.getFieldValue('stops') || [];
    const distanceUnit = form.getFieldValue('totalDistance.unit') || 'km';
    setState({ fetchingDistance: true });
    const response = await getDistanceBetweenAddresses({
      originId: stuffingAddress.key,
      destinationId: destuffingAddress.key,
      stops: stops.filter(stop => stop?.address).map(stop => { return {address: stop.address.key} }),
      unit: distanceUnit,
    });
    if (response?.isSuccess) {
      let distance = response.data?.distance?.value;
      let unit = response.data?.distance?.unit;
      const totalDistanceUnit = form.getFieldValue('totalDistance.unit') || 'km';
      if (distance && unit) {
        const conversionFactor = DistanceConverterMap?.[unit]?.[totalDistanceUnit];
        distance = conversionFactor ? distance * conversionFactor : distance;
        distance = Math.floor(distance);
        form.setFieldsValue({
          totalDistance: {
            value: distance,
            unit: totalDistanceUnit
          }
        })
      } else {
        message.error('Unable to fetch distance');
      }
    } else {
      message.error(response?.errorMessage);
    }
    setState({ fetchingDistance: false });
  }
  const renderTotalDistance = () => {
    const {
      masterData: { distanceUnits },
    } = props;
    
    return (
      <>
        <Row style={{ width: '100%', alignItems: 'center' }}>
          <Col span={4} style={{ marginTop: '5px' }}>
            <span className={parentClasses.formTitles}>Total Distance</span>
          </Col>
          <Col span={20} style={{ paddingLeft: '16px' }}>
            <div style={{ width: '70%', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <FormItem style={{ marginBottom: '0px', width: '40%' }}>
                {getFieldDecorator('totalDistance.value', {
                  // rules: [{ required: true, message: 'required' }]
                })(
                  <InputNumber
                    data-testId={'totalDistanceInput'}
                    style={{ width: '100%' }}
                    placeholder="0"
                    min={0}
                    disabled={isBooking || isPrefilling}
                  />
                )}
              </FormItem>
              <FormItem style={{ marginBottom: '0px', width: '16%' }}>
                {getFieldDecorator("totalDistance.unit", {
                  initialValue: defaultDistanceUnit || 'km',
                })(
                  <Select style={{ width: '100%' }} disabled={isBooking || isPrefilling}>
                    {distanceUnits?.map((unit) => (
                      <Select.Option key={unit}>{unit}</Select.Option>
                    ))}
                  </Select>
                )}
              </FormItem>
              <Button
                disabled={isBooking}
                className={classes.getDistanceButton}
                loading={state.fetchingDistance}
                onClick={getDistance}
                data-testid={'getDistanceButton'}
              >
                Get Distance
              </Button>
            </div>
          </Col>
        </Row>
      </>
    );
  };

  const getTotalGrossWeightLCL = (key) => {
    const {
      form: { getFieldValue },
    } = props;
    const grossWeight = getFieldValue(`packagingDetails[${key}].weight.value`) || 0;
    const quantity = getFieldValue(`packagingDetails[${key}].count`);
    const unit = getFieldValue(`packagingDetails[${key}].weight.unit`);
    return `${(grossWeight * quantity).toFixed(2)} ${unit}`;
  };

  const getMode = () => {
    return getFieldValue('mode') || InquiryModes.DOMESTIC;
  };

  const modeRef = React.useRef(getFieldValue('mode') || InquiryModes.DOMESTIC);
  React.useEffect(() => {
    const currentMode = getMode();
    const prevMode = modeRef.current;
    if ((currentMode === InquiryModes.RPTL|| currentMode === InquiryModes.LCL) && currentMode !== prevMode) {
      getProducts('');
    }
    // Clear addresses when switching between RPTL and DOMESTIC modes
    // BUT only if it's an actual mode switch (not initial load during edit/booking)
    // AND only if addresses haven't been prefilled yet
    if ((prevMode === InquiryModes.RPTL && currentMode === InquiryModes.DOMESTIC) ||
        (currentMode === InquiryModes.RPTL && prevMode === InquiryModes.DOMESTIC)) {
      // Don't clear if we're editing/booking (addresses are prefilled)
      // Don't clear if addresses are already set in form
      if (!isEdit && !isBooking && !inquiryId) {
        const stuffingAddress = form.getFieldValue('stuffingAddress');
        const deStuffingAddress = form.getFieldValue('deStuffingAddress');
        
        if (!stuffingAddress && !deStuffingAddress) {
          setStuffingTruckingAddress(undefined);
          setDeStuffingTruckingAddress(undefined);
          setFieldsValue({
            stuffingAddress: undefined,
            deStuffingAddress: undefined,
          });
        }
      }
    }
    modeRef.current = currentMode;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getFieldValue('mode')]);



  const getContainerCount = () => {
    return disableRatesSearchParams()
      ? discoverRatesSelectedFilters?.noOfContainers || 1
      : 1;
  };

  const renderUnitLabel = (label) => {
    return <div
      style={{ paddingRight: 30, width: '13.5%',
        color: '#262626',
        fontSize: tokens.fontSize.small, }}
    >
      {label}
    </div>;
  };

  const isEditOrBookingInquiry = () => {
    return isEdit || isBooking;
  };

  const isBookedFromSpotRates = () => {
    return false;
  };


  const handleProductSearchForCountandUnit = (query) => {
    setState({ isProductListLoading: true });
    debouncedProductQuery(query);
  };

  const fromDiscoverRates = () => {
    return disableRatesSearchParams();
  };

  const disableRatesSearchParams = () => {
    const { location } = props;
    return location?.state?.disableFields ?? false;
  };

  const isBookingFromSpot = () => {
    // const { source } = state;
    // const isBookingFromSpot = source === BookingSource.DIRECT_BOOKING || source === BookingSource.SPOT_BOOKING;
    return false;
  };

  const isSpotInquiryOrBooking = () => {
    return disableRatesSearchParams() || isBookingFromSpot();
  }

  const handleDimensionChange = (
    key,
    l: any = undefined,
    b: any = undefined,
    h: any = undefined,
    unit: any = undefined
  ) => {
    const {
      form: { getFieldValue, setFieldsValue },
      masterData: { volumeConverterMap },
    } = props;
    const length = l || getFieldValue(`packagingDetails[${key}].packageDimension.length`);
    const breadth = b || getFieldValue(`packagingDetails[${key}].packageDimension.breadth`);
    const height = h || getFieldValue(`packagingDetails[${key}].packageDimension.height`);
    const lengthUnit = unit || getFieldValue(`packagingDetails[${key}].packageDimension.unit`);
    const volUnit = getFieldValue(`packagingDetails[${key}].volume.unit`);
    const conversionFactor =
      volumeConverterMap[lengthUnit] &&
      volumeConverterMap[lengthUnit][volUnit] &&
      volumeConverterMap[lengthUnit][volUnit];
    const newVol =
      length && length > 0 && breadth && breadth > 0 && height && height > 0 && conversionFactor
        ? length * breadth * height * conversionFactor
        : undefined;

    const type = getFieldValue(`packagingDetails[${key}].type`);
    const isDrumOrRoll = type === 'DRUM' || type === 'ROLL';
    isDrumOrRoll
    ? setFieldsValue({
      [`packagingDetails[${key}].packageDimension.breadth`]: length,
      [`packagingDetails[${key}].volume.value`]: newVol ? +newVol : undefined,
    })
    : setFieldsValue({
      [`packagingDetails[${key}].volume.value`]: newVol ? +newVol : undefined,
    });
  };


  const renderLBHUnit = (key, showLabel = false) => {
    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue },
      classes,
      booking,
      masterData: { lengthUnits, weightsUnits, volumeUnits },
      discoverRatesSearchFilters //undefined for now, since spotRates for Domestic is not supported
    } = props;
    const formConfig = CreateEnquiryFormConfig[getMode()];
    const packageTypes = props.masterData[formConfig.packageType];

    const type = getFieldValue(`packagingDetails[${key}].type`);
    const isDrumOrRoll = type === 'DRUM' || type === 'ROLL';

    if (
     ( !CreateEnquiryFormConfig[getMode()].packagingDetailsVisible &&
      getFieldValue(`type${key}`) !== 'OPEN_TOP' &&
      !getFieldValue(`gauageCheckbox${key}`)) && ( !isRPTL))
      return null;
    const disabledFields = getMode() !== 'FCL' && isBooking;
    return (
      <React.Fragment>
        <Input.Group compact>
          <div style={{ marginBottom: '0px', width: '23%', marginRight: '3px' }}>
            {showLabel && (
              <div className={classNames(parentClasses.formTitles, parentClasses.containerTitle)}>Length</div>
            )}
            <FormItem className={classes.formItemSmallError}>
              {getFieldDecorator(`packagingDetails[${key}].packageDimension.length`, {
                initialValue: disableRatesSearchParams() && discoverRatesSearchFilters?.length || undefined,
                rules: [
                  { required: (!!formConfig.dimensionsMandatory 
                    // && (!this.props.booking && !this.fromDiscoverRates)
                    ) || showLabel, 
                    message: 'Required' },
                ],
              })(
                <InputNumber
                  disabled={disabledFields || disableRatesSearchParams()}
                  placeholder="Length"
                  style={{ width: '100%' }}
                  min={0}
                  type="number"
                  onChange={(val) => handleDimensionChange(key, val)}
                />
              )}
            </FormItem>
          </div>
          <div style={{ marginBottom: '0px', width: '23%', marginRight: '3px' }}>
            {showLabel && (
              <div className={classNames(parentClasses.formTitles, parentClasses.containerTitle)}>Breadth</div>
            )}
            <FormItem className={classes.formItemSmallError}>
              {getFieldDecorator(`packagingDetails[${key}].packageDimension.breadth`, {
                initialValue: disableRatesSearchParams() && discoverRatesSearchFilters?.breadth || undefined,
                rules: [
                  { required: (!!formConfig.dimensionsMandatory 
                    // && (!this.props.booking && !this.fromDiscoverRates)
                    ) || showLabel, 
                    message: 'Required' },
                ],
              })(
                <InputNumber
                  disabled={disabledFields || isDrumOrRoll || disableRatesSearchParams()}
                  placeholder="Breadth"
                  style={{ width: '100%' }}
                  min={0}
                  type="number"
                  onChange={(val) => handleDimensionChange(key, undefined, val)}
                />
              )}
            </FormItem>
          </div>
          <div style={{ marginBottom: '0px', width: '23%', marginRight: '3px' }}>
            {showLabel && (
              <div className={classNames(parentClasses.formTitles, parentClasses.containerTitle)}>Height</div>
            )}
            <FormItem className={classes.formItemSmallError}>
              {getFieldDecorator(`packagingDetails[${key}].packageDimension.height`, {
                initialValue: disableRatesSearchParams() && discoverRatesSearchFilters?.height || undefined,
                rules: [
                  { required: (!!formConfig.dimensionsMandatory 
                    // && (!this.props.booking && !this.fromDiscoverRates)
                    ) || showLabel, 
                    message: 'Required' },
                ],
              })(
                <InputNumber
                  disabled={disableRatesSearchParams() || disabledFields}
                  placeholder="Height"
                  style={{ width: '100%' }}
                  min={0}
                  type="number"
                  onChange={(val) => handleDimensionChange(key, undefined, undefined, val)}
                />
              )}
            </FormItem>
          </div>
          <div style={{ marginBottom: '0px', width: '23%', marginRight: '10px' }}>
            {showLabel && (
              <div className={classNames(parentClasses.formTitles, parentClasses.containerTitle)}>Unit</div>
            )}
            <FormItem className={classes.formItemSmallError}>
              {getFieldDecorator(`packagingDetails[${key}].packageDimension.unit`, {
                initialValue: discoverRatesSearchFilters?.dimensionUnit || 'cm',
                // rules: [
                //   {
                //     required: (!!formConfig.dimensionsMandatory && !this.fromDiscoverRates()) || !disabledFields || showLabel,
                //     message: 'Required',
                //   },
                // ],
              })(
                <Select
                  disabled={disabledFields || disableRatesSearchParams()}
                  placeholder="Unit"
                  allowClear={false}
                  style={{ width: '100%' }}
                  onChange={(val) =>
                    handleDimensionChange(key, undefined, undefined, undefined, val)
                  }
                >
                  {lengthUnits?.map((unit) => (
                    <Select.Option key={unit}>{unit}</Select.Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </div>
        </Input.Group>
      </React.Fragment>
    );
  };

  const getCalculatedTotalVolume = (key) => {
    const {
      form: { getFieldValue },
    } = props;
    const volume = getFieldValue(`packagingDetails[${key}].volume.value`);
    const quantity = getFieldValue(`packagingDetails[${key}].count`) || 1;
    const unit = getFieldValue(`packagingDetails[${key}].volume.unit`);
    return (volume ? `${(volume * quantity).toFixed(2)}`: `0.00 `) + `${unit}`;
  }

  const renderCloseIcon = (key) => {
    return key > 0 ? (
      <Icon
        type="close"
        style={{ cursor: 'pointer', color: 'red' }}
        onClick={() => {
          updateDomesticPackagingDetailsKeysParent({
            packagingDetailsKeys: packagingDetailsKeys.filter((k) => k !== key),
          });
        }}
      />
    ) : null
  }


  const handleVolumeChange = (key, unit: any = undefined, val: any = undefined) => {
    const {
      form: { getFieldValue, setFieldsValue },
      masterData: { volumeConverterMap },
    } = props;
    if (unit) {
      const length = getFieldValue(`packagingDetails[${key}].packageDimension.length`);
      const breadth = getFieldValue(`packagingDetails[${key}].packageDimension.breadth`);
      const height = getFieldValue(`packagingDetails[${key}].packageDimension.height`);
      const lengthUnit = getFieldValue(`packagingDetails[${key}].packageDimension.unit`);
      const conversionFactor =
        volumeConverterMap[lengthUnit] && volumeConverterMap[lengthUnit][unit];
      const newVol =
        length && length > 0 && breadth && breadth > 0 && height && height > 0 && conversionFactor
          ? length * breadth * height * conversionFactor
          : undefined;
      if (isValidNumber(newVol)) {
        setFieldsValue({
          [`packagingDetails[${key}].volume.value`]: newVol,
        });
      }
    } else if (val !== getFieldValue(`packagingDetails[${key}].volume.value`)) {
      setFieldsValue({
        [`packagingDetails[${key}].packageDimension.breadth`]: undefined,
        [`packagingDetails[${key}].packageDimension.length`]: undefined,
        [`packagingDetails[${key}].packageDimension.height`]: undefined,
      });
    }
  };

  //this is copied up from CreateEnquiry.tsx since using same function in child is not possible
  const renderPackagingDetails = () => {
    const {
      booking,
      masterData: { lengthUnits, weightsUnits, volumeUnits },
      discoverRatesSearchFilters, //undefined for now, since spotRates for Domestic is not supported
    } = props;
    const { packagingDetails } = state;
    const formConfig = CreateEnquiryFormConfig[getMode()];
    const packageTypes = props.masterData[formConfig.packageType];
    if (!CreateEnquiryFormConfig[getMode()].packagingDetailsVisible && ( !isRPTL)) return null;
    const disabledFields = isBooking || isPrefilling;
    return (
      <Row
        gutter={24}
        style={{
          marginBottom: '25px',
          marginRight: '10px',
          verticalAlign: 'middle',
        }}
      >
        <Col span={3}>
          <span
            style={{
              whiteSpace: 'nowrap',
              display: 'flex',
              flexDirection: 'column',
              lineHeight: 'unset',
            }}
          >
            <span className={parentClasses.formTitles} >Packaging Details<Asterisk /></span>
            <span 
            style={{
              "overflowWrap": "break-word",
              "wordWrap": "break-word",
              "hyphens": "auto",
              "whiteSpace": "normal",
              "lineHeight": "15px",
            }}
              className={classes.fontItalic}
              >(Dimensions are per package)</span>
          </span>
        </Col>
        <Col span={21}>
          <Row gutter={10} >
            <Col span={2} style={{ paddingLeft: '5px' }}>
              Quantity
            </Col>
            <Col span={2}>Type<Asterisk /></Col>
            <Col span={7}>
              <div style={{ width: '22%', display: 'inline-block', marginRight: '3px' }}>
                Length
              </div>
              <div style={{ width: '22%', display: 'inline-block', marginRight: '3px' }}>
                Breadth
              </div>
              <div style={{ width: '22%', display: 'inline-block', marginRight: '3px' }}>
                Height
              </div>
              <div style={{ width: '22%', display: 'inline-block' }}>Unit</div>
            </Col>
            {(
              <Col span={4}>
                <div style={{ width: '57%', display: 'inline-block' }}>Volume<Asterisk /></div>
                <div style={{ width: '35%', display: 'inline-block' }}>Unit</div>
              </Col>
            )}
            <Col span={4}>
              <div style={{ width: '57%', display: 'inline-block' }}>Gross Weight<Asterisk /></div>
              <div style={{ width: '35%', display: 'inline-block' }}>Unit</div>
            </Col>
            {(
              <Col span={3} style={{ textAlign: 'center', marginRight: '-15px' }}>
                <div style={{ display: 'inline-block', fontStyle: 'italic', fontSize: `${tokens.fontSize.small}px` }}>
                  Total Gross Wt
                </div>
              </Col>
            )}
            
            {(
              <Col span={2} style={{ textAlign: 'center', marginRight: '-15px' }}>
                <div style={{ display: 'inline-block', fontStyle: 'italic', fontSize: `${tokens.fontSize.small}px` }}>
                  Total Volume
               </div>
              </Col>
            )}
          </Row>
          {packagingDetailsKeys.map((key) => {
            return (
              <Row key={key} gutter={10}>
                <Col span={2}>
                  <FormItem style={{ marginBottom: '0px' }}>
                    {getFieldDecorator(`packagingDetails[${key}].count`, {
                      initialValue: disableRatesSearchParams() && discoverRatesSearchFilters?.count || 1,
                      rules: [{ required: true, message: 'required' }],
                    })(
                      <InputNumber
                        placeholder="Count"
                        style={{ width: '100%' }}
                        min={1}
                        type="number"
                        precision={0}
                        disabled={
                           getFieldValue(`packagingDetails[${key}].packageDimension.length`) &&
                          (isBookingFromSpot() || discoverRatesSearchFilters?.count)
                        }
                        onChange={(val: any) => {
                          const grossWeight = getFieldValue(
                            `packagingDetails[${key}].weight.value`
                          );
                          if (isBookingFromSpot()) {
                            setFieldsValue({
                              [`packagingDetails[${key}].weight.value`]:
                                (val && packagingDetails?.[key]?.weight) ? (packagingDetails?.[key]?.weight?.value / val): undefined,
                            });
                            setFieldsValue({
                              [`packagingDetails[${key}].volume.value`]:
                                (val && packagingDetails?.[key]?.volume) ? (packagingDetails?.[key]?.volume?.value / val): undefined,
                            });
                          }
                        }}
                      />
                    )}
                  </FormItem>
                </Col>
                <Col span={2}>
                  <FormItem style={{ marginBottom: '0px' }}>
                    {getFieldDecorator(`packagingDetails[${key}].type`, {
                      rules: [{ required: true, message: 'required' }],
                      initialValue: formConfig.defaultPackageType || undefined,
                    })(
                      <Select
                        disabled={disabledFields}
                        placeholder="Type"
                        style={{ width: '100%' }}
                        onChange={(val) => {
                          const isDrumOrRoll = val === 'DRUM' || val === 'ROLL';
                          const len = getFieldValue(
                            `packagingDetails[${key}].packageDimension.length`
                          );
                          isDrumOrRoll &&
                            setFieldsValue({
                              [`packagingDetails[${key}].packageDimension.breadth`]: len,
                            });
                        }}
                      >
                        {packageTypes &&
                          Object.keys(packageTypes).map((key) => (
                            <Select.Option key={key}>{packageTypes[key]}</Select.Option>
                          ))}
                      </Select>
                    )}
                  </FormItem>
                </Col>
                <Col span={7}>{renderLBHUnit(key)}</Col>
                {(
                  <Col span={4}>
                    <Input.Group compact>
                      <FormItem style={{ marginBottom: '0px', width: '55%', marginRight: '3px' }}>
                        {getFieldDecorator(`packagingDetails[${key}].volume.value`, {
                          initialValue: disableRatesSearchParams() ?
                            ((discoverRatesSearchFilters?.totalVolume?.value ?? 0 ) / (getFieldValue(`packagingDetails[${key}].count`)|| 1))
                            : undefined,
                          rules: [{ required: !formConfig.isAir, message: 'required' }],
                        })(
                          <InputNumber
                            type="number"
                            placeholder="Volume"
                            style={{ width: '100%' }}
                            min={0}
                            onChange={(val) => handleVolumeChange(key, undefined, val)}
                            disabled={disabledFields || (formConfig.isAir || isSpotInquiryOrBooking())}
                          />
                        )}
                      </FormItem>
                      <FormItem style={{ marginBottom: '0px', width: '35%' }}>
                        {getFieldDecorator(`packagingDetails[${key}].volume.unit`, {
                          initialValue: discoverRatesSearchFilters?.totalVolume?.unit || 'cbm',
                          rules: [{ required: !disabledFields, message: 'required' }],
                        })(
                          <Select
                            placeholder="Unit"
                            allowClear={false}
                            style={{ width: '100%' }}
                            onChange={(val) => handleVolumeChange(key, val)}
                            disabled={disabledFields || isSpotInquiryOrBooking()}
                          >
                            {volumeUnits &&
                              volumeUnits.map((unit) => (
                                <Select.Option key={unit}>{unit}</Select.Option>
                              ))}
                          </Select>
                        )}
                      </FormItem>
                    </Input.Group>
                  </Col>
                )}
                <Col span={4}>
                  <Input.Group compact>
                    <FormItem style={{ marginBottom: '0px', width: '55%', marginRight: '3px' }}>
                      {getFieldDecorator(`packagingDetails[${key}].weight.value`, {
                        ...({
                          initialValue: disableRatesSearchParams() ?
                          ((discoverRatesSearchFilters?.grossWeight?.value ?? 0 ) / (getFieldValue(`packagingDetails[${key}].count`)|| 1))
                          : undefined,
                          rules: [{ required: true, message: 'required' }],
                        }),
                      })(
                        <InputNumber
                          type="number"
                          disabled={disabledFields || isSpotInquiryOrBooking()}
                          placeholder="Gross Weight"
                          style={{ width: '100%' }}
                          min={0}
                          // onChange={(val: any) => {
                          //   if (getMode() === AIRCARGO) {
                          //     const count = getFieldValue(`packagingDetails[${key}].count`);
                          //     setFieldsValue({
                          //       [`packagingDetails[${key}].totalWeight.value`]: val
                          //         ? count * val
                          //         : undefined,
                          //     });
                          //   }
                          // }}
                        />
                      )}
                    </FormItem>
                    <FormItem style={{ marginBottom: '0px', width: '35%' }}>
                      {getFieldDecorator(`packagingDetails[${key}].weight.unit`, {
                        initialValue: discoverRatesSearchFilters?.grossWeight?.unit || 'kg',
                        ...({
                          rules: [{ required: !disabledFields, message: 'required' }],
                        }),
                      })(
                        <Select
                          placeholder="Unit"
                          onChange={(val) => {
                            setFieldsValue({
                              [`packagingDetails[${key}].totalWeight.unit`]: val,
                            });
                          }}
                          disabled={disabledFields || isSpotInquiryOrBooking()}
                          allowClear={false}
                          style={{ width: '100%' }}
                        >
                          {weightsUnits &&
                            weightsUnits.map((unit) => {
                              // Skipping "cases" unit as it is required only in containerUnits
                              if (EXCLUDED_WEIGHT_UNITS.includes(unit)) {
                                return null;
                              } else {
                                return (
                                  <Select.Option key={unit}>{unit}</Select.Option>
                                );
                              }
                            })}
                        </Select>
                      )}
                    </FormItem>
                  </Input.Group>
                </Col>
                {(
                  <>
                    <Col span={3} style={{ marginRight: '-15px' }}>
                      <div style={{ textAlign: 'center', marginTop: '8px' }}>
                        {getTotalGrossWeightLCL(key)}
                      </div>
                    </Col>
                    <Col span={2} style={{ marginRight: '-15px' }}>
                      <div style={{ textAlign: 'center', marginTop: '8px' }}>
                        {getCalculatedTotalVolume(key)}
                      </div>
                    </Col>
                  </>
                )}
                {<div style={{ paddingTop: '8px', position: 'absolute', right: '-14px' }}>
                  {renderCloseIcon(key)}
                </div>}
              </Row>
            );
          })}
          {!disabledFields && !disableRatesSearchParams() && <Row>
            <Col style={{ paddingTop: '10px' }}>
              <a
                type="plus-circle"
                style={{
                  cursor: 'pointer',
                  color: disabledFields ? 'grey' : tokens.colors.primary,
                }}
                onClick={() => {
                  if (disabledFields) return;
                  updateDomesticPackagingDetailsKeysParent({
                    packagingDetailsKeys: packagingDetailsKeys.concat(packagingDetailsKeys.length),
                  });
                }}
              >
                + Add More
              </a>
            </Col>
          </Row>}
        </Col>
      </Row>
    );
  };


  const disablePastDate = (current: any) => {
    return current && current < moment().endOf('day');
  };

  const renderStackable = () => {
    const {
      form: { getFieldDecorator },
      classes,
      booking,
    } = props;
    if (!CreateEnquiryFormConfig[getMode()].stackableVisible) return null;
    // const disabledFields = this.getMode() !== 'FCL' && booking;
    return (
      <div
        className={parentClasses.rowDiv}
        style={{
          height: '30px',
          marginBottom: '15px',
        }}
      >
        <span
          className={classNames(parentClasses.formTitles, parentClasses.gridLabelWidth)}
          style={{ whiteSpace: 'nowrap', width: '12.5%', marginRight: '6px' }}
        >
          Stackable<Asterisk />
        </span>
        <div className={classNames(parentClasses.rowDiv, parentClasses.gridInputFieldWidth)}>
          <FormItem style={{ marginBottom: '10px' }}>
            {getFieldDecorator('stackable', {
              rules: [
                {
                  validator: (rule, value, callback) => {
                    if (value === undefined || value === '') {
                      callback('Please select an option');
                    } else {
                      callback(); // null, true, or false are all valid
                    }
                  },
                },
              ],
              initialValue: true,
            })(
              <RadioGroup disabled={isBooking}>
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
                 <Radio value={null}>No Info</Radio>
              </RadioGroup>
            )}
          </FormItem>
        </div>
      </div>
    );
  };

  
  const renderProductDropdown = (menu: React.ReactNode) => {
    const { parentClasses, enableAddressMasterInMenu, permissions } = props;
    const { isProductListLoading } = state;
    if (isProductListLoading) return <Spin style={{ marginLeft: '45%' }} />;
    const addProduct = 
      enableAddressMasterInMenu
        ? hasMasterCategoryEditPermission('PRODUCT', permissions)
        : true
    
    return (
      <React.Fragment>
        {menu}
        { addProduct &&
          <div
            className={parentClasses.addProduct}
            onMouseDown={(e) => stops(e)}
            onClick={() => setState({ addProduct: true })}
          >
            + Add Product
          </div>
        }
      </React.Fragment>
    );
  };

  const handleAddProduct = () => {
    setState({ addProduct: false });
  }

  const handleProductChange = (query) => {
    setState({ isProductListLoading: true });
    debouncedProductQuery(query);
  };

  const getProducts = async (searchQuery) => {
    setState({ isProductListLoading: true });
    const requestId = latestProductSearchRequestId.current + 1;
    latestProductSearchRequestId.current = requestId;
    let productDetailList = [];
    try {
      const response = await searchProduct({ searchQuery });
      if (requestId !== latestProductSearchRequestId.current) return [];

      if (response.isSuccess) {
        productDetailList = response.data?.map((item) => ({
          disabled: item.status === 'INACTIVE',
          key: item.id,
          referenceNumber: item.referenceNumber,
          label: `${item.internalName} (${item.hsCode} - ${item.remark}) [${item.referenceNumber}]`,
          value: item.internalName,
          organisationId: item.organisationId,
          cargoType: item.cargoType,
          cargoProductType: item.cargoProductType,
          containerAndQuantityDetails: item.containerAndQuantityDetails,
        }));
      }
      setState({
        productDetailList,
        isProductListLoading: false,
      });
      return productDetailList;
    } catch (error) {
      if (requestId !== latestProductSearchRequestId.current) return [];
      setState({
        isProductListLoading: false,
      });
      return [];
    }
  };

  const getProductsRef = React.useRef(getProducts);
  React.useEffect(() => {
    getProductsRef.current = getProducts;
  });

  const debouncedProductQuery = React.useMemo(() => debounce((query: string) => {
    getProductsRef.current(query);
  }, 300), []);

  React.useEffect(() => () => {
    debouncedProductQuery.cancel();
  }, []);

  // const renderProductDetails = (styles = {}) => {
  //   const { classes } = props;
  //   const { productDetailList } = state;
  //   const filteredProductDetailList = productDetailList.filter(product => {
  //                     if (isEdit || isBooking) {
  //                       return product.organisationId === shipperId;
  //                     }
  //                     return product.organisationId === organisationId;
  //                   })
  //   const { getFieldDecorator } = props.form;
  //   return (
  //     <FormItem className={classes.formItemSmallError} style={{ width: '89%', ...styles }}>
  //       {getFieldDecorator('productObj', {
  //         rules: [{ required: isProductMandatory(), message: 'Required' }],
  //       })(
  //         <Select
  //           mode="default"
  //           showArrow
  //           showSearch
  //           placeholder="Product Name And Details"
  //           style={{ width: '100%' }}
  //           optionLabelProp={'data-value'}
  //           labelInValue
  //           allowClear
  //           filterOption={(input, option) => true}
  //           onFocus={() => handleProductChange('')}
  //           onSearch={(searchQuery) => handleProductChange(searchQuery)}
  //           dropdownRender={(menu) => renderProductDropdown(menu)}
  //           disabled={isBooking}
  //         >
  //           {filteredProductDetailList?.map(
  //             (item) =>
  //               !item.disabled && (
  //                 <Select.Option key={item.key} data-value={`${item.value} [${item.referenceNumber}]`} disabled={item.disabled}>
  //                   <Tooltip
  //                     title={item.label}
  //                     placement="topLeft"
  //                     mouseEnterDelay={0.5}
  //                     overlayStyle={{ fontSize: `${tokens.fontSize.small}px`, width: '100%' }}
  //                   >
  //                     {item.label}
  //                   </Tooltip>
  //                 </Select.Option>
  //               )
  //           )}
  //         </Select>
  //       )}
  //     </FormItem>
  //   );
  // };


  const renderProductDetailsWrapper = () => {
    return (
      <div
        className={parentClasses.rowDiv}
        style={{
          height: '30px',
          marginBottom: '8px',
        }}
      >
        <span
          className={classNames(parentClasses.formTitles,parentClasses.gridLabelWidth)}
        >
          Product Details{isProductMandatory() ? <Asterisk /> : null}
        </span>
        <div 
          className={classNames(parentClasses.rowDiv,parentClasses.gridInputFieldWidth)}
          style={{ width: '80%' }}
        >
          {renderProductDetails()}
        </div>
      </div>
    );
  };

  const renderContractDuration = () => {
    const isDraft = form.getFieldValue('isDraft');
    const isRequired = (isDraft && draftMandatoryFields?.includes('preferredSailingRange')) || !isDraft;
    
    return (
      <>
      <div className={parentClasses.rowDiv}>
        <span className={parentClasses.formTitles} style={{ width: '23%' }}>
            Contract Duration{isRequired ? <Asterisk /> : ''}
        </span>
        <div style={{ marginLeft: '18px' }}>
          <FormItem className={classes.formItemSmallError} style={{ width: '100%' }}>
            {getFieldDecorator('preferredSailingRange', {
              rules: [
                {
                  required: isRequired,
                  message: 'Contract Duration is required',
                },
              ],
              initialValue: isRequired ? [
                moment().endOf('day').add(7, 'day'),
                moment().endOf('day').add(14, 'day'),
              ] : undefined,
            })(
              <RangePicker
                disabled={isBooking}
                allowClear
                disabledDate={disablePastDate}
                format="DD MMM YYYY"
                style={{ width: '80%', marginBottom: '0px' }}
                onChange={(date: [Moment, Moment]) => {
                  setState({
                    preferredSailingRange: date,
                  });
                }}
              />
            )}
          </FormItem>
        </div>
      </div>
      </>
    );
  };

  const s3LinkRequest = async ({ file }, ind) => {
    updateDomesticDocsParent({
      docs: {
        ...latestDocsRef.current,
        [ind]: {
          ...latestDocsRef.current[ind],
          uploading: true,
        },
      },
    });
    const extension = getFileExtension(file.name);
    const response = await fileUploadOnS3({
      extension,
      fileName: file.name,
      document_type: file.type,
      initialPath: 'inquiry',
    });
    if (response.isSuccess) {
      const upload = await uploadImageToS3(file, response.data.post, extension);
      if (upload.isSuccess) {
        updateDomesticDocsParent({
          docs: {
            ...latestDocsRef.current,
            [ind]: {
              ...latestDocsRef.current[ind],
              file: {
                ext: extension,
                name: file.name,
                s3Link: response.data.get,
              },
              uploading: false,
            },
          },
        });
      }
    } else {
      message.error(response.errorMessage);
      updateDomesticDocsParent({
        docs: {
          ...latestDocsRef.current,
          [ind]: {
            ...latestDocsRef.current[ind],
            uploading: false,
          },
        },
      });
    }
  };

  const renderDocumentUpload = () => {
    const { masterData } = props;
    return (
      <div
        className={parentClasses.rowDiv}
        style={{
          marginBottom: '25px',
          verticalAlign: 'middle',
        }}
        id="docUpload"
      >
        <div style={{ width: '25%', marginTop: '10px', flexShrink: 0, marginRight: '8px' }}>
          <span className={parentClasses.formTitles}>
            Documents
          </span>
        </div>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              {Object.keys(docs).map((doc) => {
                return (
                  <div
                    className={parentClasses.rowDiv}
                    key={doc}
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      marginBottom: '8px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignContent: 'center',
                        width: '80%',
                      }}
                    >
                      <Select
                        value={docs[doc].type}
                        optionLabelProp="data-value"
                        onChange={(type) => {
                          updateDomesticDocsParent({
                            docs: {
                              ...props.docs,
                              [doc]: {
                                ...props.docs[doc],
                                type,
                              },
                            },
                          });
                        }}
                        style={{ width: '80%', minWidth: '63%' }}
                      >
                        {masterData.allowedDocumentTypes &&
                          Object.keys(masterData.allowedDocumentTypes).map((item) => {
                            return (
                              <Option
                                key={item}
                                data-value={masterData.allowedDocumentTypes[item]}
                              >
                                {masterData.allowedDocumentTypes[item]}
                              </Option>
                            );
                          })}
                      </Select>
                      <Upload
                        style={{ width: '25%' }}
                        showUploadList={false}
                        multiple={false}
                        customRequest={(file: any) => s3LinkRequest(file, doc)}
                      >
                        <Button style={{ marginLeft: '10px' }}>
                          <Icon type="upload" /> Upload
                        </Button>
                      </Upload>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignContent: 'center',
                        width: '40%',
                        marginLeft: '3%',
                      }}
                    >
                      {docs[doc].uploading && (
                        <div style={{ width: '5%' }}>
                          <Spin
                            indicator={
                              <Icon
                                type="loading"
                                style={{
                                  fontSize: tokens.fontSize.h1,
                                  marginTop: '5px',
                                }}
                                spin
                              />
                            }
                          />
                        </div>
                      )}
                      {docs[doc].file && docs[doc].file.s3Link ? (
                        <div
                          style={{
                            width: '100%',
                            paddingTop: '3px',
                            display: 'flex',
                            flexDirection: 'row',
                          }}
                        >
                          <a
                            href={docs[doc].file.s3Link}
                            style={{ 
                            marginRight: '5%', 
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          >
                            {docs[doc].file.name}
                          </a>
                          <Icon
                            type="close"
                            style={{
                              color: 'red',
                              cursor: 'pointer',
                              marginLeft: '1%',
                              marginTop: '7px',
                              marginRight: '5%',
                            }}
                            onClick={() => {
                              const newDocs = {
                                ...docs,
                                [doc]: {
                                  ...docs[doc],
                                  file: {},
                                },
                              };
                              updateDomesticDocsParent({
                                docs: newDocs,
                              });
                            }}
                          />
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                    </div>
                  </div>
                );
              })}
              <div className={parentClasses.rowDiv}>
                <Icon
                  type="plus"
                  style={{
                    height: '18px',
                    width: '18px',
                    color: tokens.colors.primary,
                    paddingTop: '2px',
                  }}
                />
                <a
                  onClick={() => {
                    const newKey = docsKey;
                    updateDomesticDocsParent({
                      docs: {
                        ...docs,
                        [newKey]: {
                          file: {},
                          type: 'CUSTOM INVOICE',
                        },
                      }});
                  }}
                  style={{
                    color: tokens.colors.primary,
                    marginLeft: '3px',
                    float: 'left',
                  }}
                >
                  Add more
                </a>
              </div>
            </div>
        </div>
    );
  };

  const renderIsHighValue = () => {
    const isDraft = form.getFieldValue('isDraft');
    const isRequired = (isDraft && draftMandatoryFields?.includes('isHighValueInsuranceRequired')) || !isDraft;
    
    return (
      <div className={parentClasses.rowDiv}>
        <div style={{ width: '25%' , marginTop: '10px', flexShrink: 0, marginRight: '8px'}}>
          <span className={parentClasses.formTitles}>High-Value <br />Insurance Required {isRequired ? <Asterisk /> : ''}</span>
        </div>
        <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
          <FormItem style={{ width: '40%' }}>
            {getFieldDecorator("isHighValueInsuranceRequired", {initialValue: false })(
              <RadioGroup disabled={isBooking}>
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
              </RadioGroup>
            )}
          </FormItem>
        </div>
      </div>
    );
  }

  const renderCargoValue = () => {
    const isRequired = form.getFieldValue('isHighValueInsuranceRequired')
    return (
      <div className={parentClasses.rowDiv}>
        <div style={{ width: '25%', marginTop: '10px', flexShrink: 0, marginRight: '8px' }}>
          <span className={parentClasses.formTitles}>Cargo Value {isRequired ? <Asterisk /> : null}</span>
        </div>
        <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
          <FormItem style={{ width: '28%' }}>
            {getFieldDecorator("cargoValue.amount", {rules: [{required: isRequired, message: 'Required'} ]})(
              <InputNumber
                min={0.1}
                style={{ width: '100%' }}
                placeholder="Rate"
                disabled={isBooking || isPrefilling} />
            )}
          </FormItem>
          <FormItem style={{ width: '25%', marginLeft: '2px' }}>
            {getFieldDecorator("cargoValue.currency", {
              initialValue: 'USD',
              required: isRequired
            })(
              <Select
                style={{ width: '100%' }}
                dropdownMatchSelectWidth={false}
                disabled={isBooking || isPrefilling}
              >
                {currencies &&
                  Object.keys(currencies).map((item) => (
                    <Select.Option key={item}>{item}</Select.Option>
                  ))}
              </Select>
            )}
          </FormItem>
          {/* <span style={{ fontStyle: 'italic', fontSize: `${tokens.fontSize.small}px`, color: '#262626', marginLeft: '6px' }}>
            Per Trailer
          </span> */}
        </div>
      </div>
    );
  };

  const renderStackableForRoadPTL = () => {
    if (getMode() !== InquiryModes.RPTL) return null;
    return renderStackable();
  };

  const renderPackagingDetailsForRoadPTL = () => {
    if (getMode() !== InquiryModes.RPTL) return null;
    return renderPackagingDetails();
  };

  const renderProductDetails = () => {
    
    const { productDetails = {}, productDetailList = [] } = state;
    const prefilling = props.prefilling;
    const organisationId = userData?.organisation_id || props.organisationId;
    const filteredProductDetailList = productDetailList.filter(product => {
      if (isEditOrBookingInquiry()) {
        return product.organisationId === shipperId;
      }
      return product.organisationId === organisationId;
    });
    const disabledFields = isBooking || prefilling;
    const mode = getMode();
    const isRequired = isProductMandatory();
    const visible = prefilling || (isBooking && mode !== 'FCL' && !isBookedFromSpotRates());
    const cargoType = getFieldValue('cargoType');
    const vehicleTypes = getFilterVehicleTypesSize('type', cargoType);
    const vehicleSizes = getFilterVehicleTypesSize('size', cargoType);
    const showProductVehicleFields = inquiryFormPrefill && mode === InquiryModes.DOMESTIC;
    const productUnits = {
      weight: masterData?.weightsUnits,
      volume: masterData?.volumeUnits,
      other: ['units', 'barrel', 'box', 'tray', 'cases']
    };
  
    return (
      <React.Fragment>
        {Object.keys(productDetails || {}).map((key, ind) => (
          <React.Fragment key={key}>
            <div
              className={classes.rowDiv}
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '8px',
                flexWrap: 'wrap',
                position: 'relative',
              }}
            >
              {/* Product Details Title */}
		              <span
		                style={{
		                  width: '12.5%',
		                  textOverflow: 'ellipsis',
		                  overflow: 'hidden',
		                  whiteSpace: 'nowrap',
		                  marginRight: '6px',
		                }}
		                className={classNames(parentClasses.formTitles, parentClasses.gridLabelWidth)}
		              >
                {ind === 0 ? <>Product Details{isRequired ? <Asterisk /> : null}</> : ''}
              </span>
    {/* Product Dropdown Section */}
    <div style={{ width: '20%', marginRight: '6px' }}>
                <div className={classNames(parentClasses.formTitles, parentClasses.containerTitle)}>Product</div>
                <FormItem className={classNames(parentClasses.formItemCountError, parentClasses.productErrorInline)}>
                  {getFieldDecorator(`productKey${key}`, {})(
                    <Select
                      mode="default"
                      disabled={visible}
                      showArrow
                      showSearch
                      placeholder="Product Name And Details"
                      style={{ width: '100%' }}
                      optionLabelProp={'data-value'}
                      labelInValue
                      allowClear
                      filterOption={(input, option) => true}
                      onFocus={() => {
                        if (productDetailList?.length === 0) {
                          handleProductSearchForCountandUnit('');
                        }
                      }}
                      onSearch={(searchQuery) => handleProductSearchForCountandUnit(searchQuery)}
                      onChange={(val: any) => handleProductChangeForDomestic(key, val)}
                      dropdownRender={(menu) => renderProductDropdown(menu)}
                    >
                      {filteredProductDetailList?.map(
                        (item) =>
                          !item.disabled && (
                            <Select.Option
                              key={item.key}
                              value={item.key}
                              data-value={`${item.value} [${item.referenceNumber}]`}
                              disabled={item.disabled}
                            >
                              <Tooltip
                                title={item.label}
                                placement="topLeft"
                                mouseEnterDelay={0.5}
                                overlayStyle={{ fontSize: `${tokens.fontSize.small}px`, width: '100%' }}
                              >
                                {item.label}
                              </Tooltip>
                            </Select.Option>
                          )
                      )}
                    </Select>
                  )}
                </FormItem>
              </div>
              {/* Count Section */}
              <div style={{ width: '7%', marginRight: '6px' }}>
                <div className={classNames(parentClasses.formTitles, parentClasses.containerTitle)}>
                  Count/Wt./Vol.
                </div>
                <FormItem className={classes.formItemSmallError}>
                  {getFieldDecorator(`productQuantity${key}`, {
                    rules: [
                      {
                        validator: (rule, value, cb) => {
                          if (!value) {
                            isRequired ? cb('Required') : cb();
                          } else if (value >= Math.pow(10, 10)) {
                            cb('Enter a small Number');
                          } else if (value < 1){
                            cb('Value must be greater than 1');
                          } else cb();
                        },
                      },
                    ],
                    initialValue: fromDiscoverRates()
                      ? discoverRatesSelectedFilters?.noOfContainers || 1
                      : isRequired
                      ? 1
                      : undefined,
                  })(
                    <InputNumber
                      type="number"
                      placeholder="Count"
                      precision={0}
                      min={getContainerCount()}
                      style={{ width: '95%' }}
                      onChange={(value) => {
                        setState(
                          {
                            productDetails: {
                              ...productDetails,
                              [key]: {
                                ...productDetails[key],
                                quantity: value,
                              },
                            },
                          },
                          () => { debouncedApplyCalculatedVehicleDetails(); }
                        );
                      }}
                    />
                  )}
                </FormItem>
              </div>

              {/* Unit Section */}
              <div style={{ width: '9%', marginRight: '6px' }}>
                <div className={classNames(parentClasses.formTitles, parentClasses.containerTitle)}>Unit</div>
                <FormItem className={classes.formItemSmallError}>
                  {getFieldDecorator(`productUnit${key}`, {
                    rules: [{ required: isRequired, message: 'Required' }],
                  })(
                    <Select
                      placeholder="Unit"
                      disabled={visible}
                      style={{ width: '100%' }}
                      optionLabelProp={'data-value'}
                      onChange={(val) => {
                        setState({
                          productDetails: {
                            ...productDetails,
                            [key]: {
                              ...productDetails[key],
                              unit: val,
                            },
                          },
                        }, () => { applyCalculatedVehicleDetails(); });
                      }}
                    >
                      {Object.keys(productUnits).map((unitKey) => (
                        <Select.OptGroup key={unitKey} label={renderUnitLabel(unitKey)}>
                          {productUnits[unitKey].map((unit) => (
                            <Select.Option key={unit} value={unit} data-value={unit}>
                              {unit}
                            </Select.Option>
                          ))}
                        </Select.OptGroup>
                      ))}
                    </Select>
                  )}
                </FormItem>
              </div>

              {showProductVehicleFields && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '6px',
                  }}
                >
                  <span
                    style={{
                      height: '28px',
                      margin: '0 8px 0 8px',
                      border: '0.95px solid #666666',
                    }}
                  />
                </div>
              )}

              {showProductVehicleFields && (
                <div style={{ width: '17%', marginRight: '6px' }}>
                  <div className={classNames(parentClasses.formTitles, parentClasses.containerTitle)}>
                    Vehicle Type
                  </div>
                  <FormItem className={classNames(parentClasses.formItemCountError, parentClasses.productErrorInline)}>
                    {getFieldDecorator(`productCnType${key}`, {
                      rules: [
                        { validator: (rule, value, callback) => {
                          if (!value) { callback(); return; }
                          const currentVehicleList = form.getFieldValue('vehicleDetails') || state.vehicleDetails;
                          const allVehicleTypes = currentVehicleList
                            .map((_item: any, i: number) => form.getFieldValue(`vehicleDetails[${i}].type`))
                            .filter(Boolean);
                          const productLabel = masterVehicleTypes[value] || value;
                          const vehicleTypeDbKeys = allVehicleTypes.map((t) => {
                            const matchingLabel = domesticVehicleTypeSizeList?.find((vt) => vt?.key?.type === t)?.label?.type;
                            return Object.entries(masterVehicleTypes).find(([, label]) => label === matchingLabel)?.[0] || t;
                          });
                          if (allVehicleTypes.length === 0 || vehicleTypeDbKeys.includes(value)) {
                            callback();
                          } else {
                            const vehicleTypeDisplayLabels = allVehicleTypes.map((t) =>
                              domesticVehicleTypeSizeList?.find((vt) => vt?.key?.type === t)?.label?.type || t
                            );
                            callback(`Product vehicle type ${productLabel} is invalid since the shipment vehicle type is ${vehicleTypeDisplayLabels.join(', ')}.\nPlease add the relevant vehicle type.`);
                          }
                        }},
                      ],
                    })(
                      <Select
                        placeholder="Vehicle Type"
                        style={{ width: '95%' }}
                        allowClear
                        disabled={visible}
                        dropdownMatchSelectWidth={false}
                        optionLabelProp="data-value"
                        onChange={(val) => {
                          setState({
                            productDetails: {
                              ...productDetails,
                              [key]: {
                                ...productDetails[key],
                                productCnType: val,
                              },
                            },
                          }, () => { applyCalculatedVehicleDetails(); });
                        }}
                      >
                        {Object.entries(masterVehicleTypes)
                          .filter(([dbKey, label]) => vehicleTypes?.some((vt) => vt?.label?.type === label))
                          .map(([dbKey, label]) => (
                            <Option key={dbKey} value={dbKey} data-value={label}>
                              {label}
                            </Option>
                          ))}
                      </Select>
                    )}
                  </FormItem>
                </div>
              )}

              {showProductVehicleFields && (
                <div style={{ width: '8%' }}>
                  <div className={classNames(parentClasses.formTitles, parentClasses.containerTitle)}>Size</div>
                  <FormItem className={classNames(parentClasses.formItemCountError, parentClasses.productErrorInline)}>
                    {getFieldDecorator(`productCnSize${key}`, {
                      rules: [
                        { validator: (rule, value, callback) => {
                          if (!value) { callback(); return; }
                          const currentVehicleList = form.getFieldValue('vehicleDetails') || state.vehicleDetails;
                          const allVehicleSizes = currentVehicleList
                            .map((_item: any, i: number) => form.getFieldValue(`vehicleDetails[${i}].size`))
                            .filter(Boolean);
                          if (allVehicleSizes.length === 0 || allVehicleSizes.includes(value)) {
                            callback();
                          } else {
                            callback(`Product vehicle size ${value} is invalid.\nAvailable shipment vehicle sizes: ${allVehicleSizes.join(', ')}`);
                          }
                        }},
                      ],
                    })(
                      <Select
                        placeholder="Size"
                        style={{ width: '95%' }}
                        allowClear
                        disabled={visible}
                        dropdownMatchSelectWidth={false}
                        onChange={(val) => {
                          setState({
                            productDetails: {
                              ...productDetails,
                              [key]: {
                                ...productDetails[key],
                                productCnSize: val,
                              },
                            },
                          }, () => { applyCalculatedVehicleDetails(); });
                        }}
                      >
                        {vehicleSizes?.map((item) => (
                          <Option key={item?.key?.size} value={item?.key?.size} data-value={item?.label?.size}>
                            {item?.label?.size}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </FormItem>
                </div>
              )}
              

              {/* Delete Product Button */}
              <div>
                {!visible &&Object.keys(productDetails).length > 1? (
                  <Tooltip title="Delete this product">
                    <Icon
                      type="close"
                      style={{
                        cursor: 'pointer',
                        color: 'red',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      onClick={() => {
                        const newProductDetails = { ...productDetails };
                        delete newProductDetails[key];
                        setState(
                          {
                            productDetails: newProductDetails,
                          },
                          () => { applyCalculatedVehicleDetails(); }
                        );
                      }}
                    />
                  </Tooltip>
                ) : null}
              </div>
            </div>

            {/* Add More Button (below the row) */}
	            {!disableRatesSearchParams() && ind === Object.keys(productDetails).length - 1 && (
	              <div style={{ display: 'flex', alignItems: 'center', position: 'absolute', left: '12.5%', bottom:'4px' }}>
                <Icon
                  type="plus"
                  style={{
                    height: '18px',
                    width: '18px',
                    color: disabledFields ? 'grey' : tokens.colors.primary,
                    paddingTop: '2px',
                  }}
                />
                <a
                  type="plus-circle"
                  style={{
                    cursor: 'pointer',
                    color: disabledFields ? 'grey' : tokens.colors.primary,
                    marginLeft: '3px',
                  }}
                  onClick={() => {
                    if (disabledFields) return;
                    const productDetailsKeysLength = Object.keys(productDetails).map(Number);
                    const newKey = productDetailsKeysLength.length > 0 ? Math.max(...productDetailsKeysLength) + 1 : 0;
                    setState({
                      productDetails: {
                        ...productDetails,
                        [newKey]: {
                          key: '',
                          quantity: 0,
                          unit: 'kg',
                          productCnType: '',
                          productCnSize: '',
                          containerAndQuantityDetails: [],
                        },
                      },
                      productDetailsKey: newKey + 1,
                    }, () => { applyCalculatedVehicleDetails(); });
                  }}
                >
                  Add More
                </a>
              </div>
            )}
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  };

  const renderStackableForRoadPTLWrapper = () => {
    if (!isRPTL) return null;
    return (
      <Row style={{ marginBottom: '20px' }}>
        {renderStackableForRoadPTL()}
      </Row>
    );
  };

  const renderPackagingDetailsWrapper = () => {
    if (!isRPTL) return null;
    return (
      <Row style={{ marginBottom: '20px' }}>
        {renderPackagingDetailsForRoadPTL()}
      </Row>
    );
  };


  const renderCompleteProductDetails = () => {
    return (
      <Row style={{ marginBottom: '20px'}}>
        {renderProductDetails()}
      </Row>
    );
  };


const renderStakeholder = () => {
  return (
    <FormItem style={{ marginBottom: '0px', width: '100%' }}>
      {getFieldDecorator('stakeholderId', {})(
        <Select
          style={{ width: '100%' }}
          disabled={isBooking || isPrefilling}
          allowClear
          showSearch
          filterOption={(inputValue, option) => true}
          optionLabelProp={'data-value'}
          data-testId={'stakeholderDropdown'}
          onSearch={(query) =>
            handleStakeholderSearch(
              stakeholderType.toUpperCase() as 'SUPPLIER' | 'SHIPPER',
              query,
            )
          }
          onFocus={() => {
            if (!stakeholder) {
              handleStakeholderSearch(
                stakeholderType.toUpperCase() as 'SUPPLIER' | 'SHIPPER',
                '',
              );
            }
          }}
          notFoundContent={
            stakeholderSearching ? <Spin style={{ marginLeft: '45%' }} /> : 'No results found'
          }
          placeholder={`Select ${stakeholderType}`}
          value={stakeholder?.org2Id}
          onChange={(stakeholderId: any) => {
            const stakeholderData = stakeholderList?.find((s) => s.org2Id === stakeholderId);
            setState({ stakeholder: stakeholderData }, () => {
                handleStakeholderChange(stakeholderData);
            });
          }}
        >
          {stakeholderList?.map((s) => (
            <Option
              key={s.org2Id}
              value={s.org2Id}
              data-value={`${s.name} (${s.code})`}
            >
              {`${s.name} (${s.code})`}
            </Option>
          ))}
        </Select>
      )}
    </FormItem>
  );
};

const renderCustomer = () => {
  return (
    <FormItem style={{ marginBottom: '0px', width: '100%' }}>
      {getFieldDecorator('customerId', {})(
        <Select
          style={{ width: '100%' }}
          disabled={isBooking || isPrefilling}
          allowClear
          showSearch
          filterOption={(inputValue, option) => true}
          optionLabelProp={'data-value'}
          data-testId={'customerDropdown'}
          onSearch={(query) => handleCustomerSearch(query)}
          onFocus={() => {
            if (!customer) {
              handleCustomerSearch('');
            }
          }}
          notFoundContent={
            customerSearching ? <Spin style={{ marginLeft: '45%' }} /> : 'No results found'
          }
          placeholder="Select Customer"
          value={customer?.org2Id}
          onChange={(customerId: any) => {
            const customerData = customerList?.find((c) => c.org2Id === customerId);
            setState({ customer: customerData }, () => {
              handleCustomerChange(customerData)
            })
          }}
        >
          {customerList?.map((c) => (
            <Option
              key={c.org2Id}
              value={c.org2Id}
              data-value={`${c.name} (${c.code})`}
            >
              {`${c.name} (${c.code})`}
            </Option>
          ))}
        </Select>
      )}
    </FormItem>
  );
};

  const stackableSection = renderStackableForRoadPTLWrapper();
  const packagingSection = renderPackagingDetailsWrapper();
  const productDetailsSection = renderCompleteProductDetails();


  return (
    <>
      {isPrefilling && (
        <div
          style={{
            height: '100%',
            width: '100%',
            textAlign: 'center',
            top: '30%',
            zIndex: 1000,
            position: 'absolute',
          }}
        >
          <Spin size="large" />
        </div>
      )}

      {(inquiryFormPrefill && !isRPTL) && (
        <>
          <Row
            gutter={24}
            style={{
              verticalAlign: 'middle',
              margin: '30px 30px 0 0',
              fontWeight: 'bold',
            }}
          >
            STAKEHOLDER DETAILS
          </Row>
          <Row
            gutter={24}
            style={{
              verticalAlign: 'middle',
              margin: '20px 30px 0 0',
            }}
          >
            <Col span={12}>
              <Row>
                <Col span={4} style={{ marginTop: '5px' }}>
                  <span className={parentClasses.formTitles}>{stakeholderType}</span>
                </Col>
                <Col span={20} style={{ paddingLeft: '32px' }}>
                  <div style={{ width: '60%' }}>{renderStakeholder()}</div>
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <div style={{ marginLeft: '80px' }}>
                <div className={parentClasses.rowDiv}>
                  <div style={{ width: '25%', marginTop: '5px' }}>
                    <span className={parentClasses.formTitles}>Customer</span>
                  </div>
                  <div style={{ width: '60%' }}>
                    {renderCustomer()}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </>
      )}

      <Row
        gutter={24}
        style={{
          verticalAlign: 'middle',
          margin: '30px 30px 0 0',
          fontWeight: 'bold',
        }}
      >
        BASIC DETAILS
      </Row>
      <Row
        gutter={24}
        style={{
          verticalAlign: 'middle',
          margin: '20px 30px 0 0',
        }}
      >
        {isRPTL && (
          <Col span={24}>
            <div className={parentClasses.rowDiv}>
              <div style={{ width: '25%', marginTop: '10px' }}>
                <span className={parentClasses.formTitles}>
                  {resolveFieldLabel('grid#type', 'Movement Type', inquiryFieldLabelMap)}
                </span>
              </div>
              <FormItem style={{ marginBottom: '0px', width: '70%' }}>
                {getFieldDecorator('serviceType', {
                  initialValue: props.defaultInquiryMovementType || 'export',
                })(
                  <RadioGroup disabled={isBooking || isPrefilling}>
                    <Radio value="export">Export</Radio>
                    <Radio value="import">Import</Radio>
                    <Radio value="trade">Trade</Radio>
                  </RadioGroup>
                )}
              </FormItem>
            </div>
          </Col>
        )}
      </Row>
      <Row
        gutter={24}
        style={{
          verticalAlign: 'middle',
          margin: '30px 30px 0 0',
        }}
      >
        <Col span={24}>
          <Timeline className={parentClasses.antTimeline} style={{ marginBottom: '10px' }}>
            {renderStuffingOrDeStuffingAddress(
              'stuffingAddress',
              stuffingAddresses,
              true,
              CargoOperationType.STUFFING,
              'originLocationId'
            )}
            {renderStopsLocations()}
            {renderAddStopButton()}
            {renderStuffingOrDeStuffingAddress(
              'deStuffingAddress',
              deStuffingAddresses,
              false,
              CargoOperationType.DESTUFFING,
              'destinationLocationId'
            )}
          </Timeline>
          <Row>
            <Col span={14}>
            {renderTotalDistance()}
            </Col>
          </Row>
          
        </Col>
        {/* <Col span={11}>
          <div style={{ marginLeft: '80px' }}>
            {!isRPTL && renderCargoDetails()}
            {!isRPTL && renderProductDetailsWrapper()}
          </div>
        </Col> */}
      </Row>
      <Row
            gutter={24}
            style={{
              verticalAlign: 'middle',
              margin: '30px 30px 0 0',
              fontWeight: 'bold',
            }}
          >
            CARGO & PRODUCT DETAILS
          </Row>
	          <Row
	            gutter={24}
	            style={{
	              verticalAlign: 'middle',
	              margin: '30px 30px 0 0',
	            }}
	          >
	            <Col span={isRPTL ? 24 : 20}>
	              <Row
	                gutter={[0, 10]}
	                style={{
	                  marginBottom: '0px',
	                  marginRight: '10px',
	                  verticalAlign: 'middle',
	                }}
	              >
	                <Col id="grid#cargoAndProduct" className={classes.rowDiv}>
	                  <div>{renderCargoDetails()}</div>
	                </Col>
	                {stackableSection && (
	                  <Col style={{ display: 'flex', flexDirection: 'column', marginBottom: '8px' }}>
	                    <div id="grid#stackable">{stackableSection}</div>
	                  </Col>
	                )}
	              </Row>
	              {packagingSection && <div id="grid#packagingDetails">{packagingSection}</div>}
	              <div id="grid#productDetails">{productDetailsSection}</div>
	            </Col>
	          </Row>
          {!isRPTL && (
            <>
              <Row
                gutter={24}
                style={{
                  verticalAlign: 'middle',
                  margin: '30px 30px 0 0',
                  fontWeight: 'bold',
                }}
              >
                VEHICLE DETAILS
              </Row>
              <Row
                gutter={24}
                style={{
                  verticalAlign: 'middle',
                  margin: '30px 30px 0 0',
                }}
              >
                <Col span={20}>{renderVehicleDetails()}</Col>
              </Row>
            </>
          )}
        {/* </>
      ) : (
        <>
          <Row
            gutter={24}
            style={{
              verticalAlign: 'middle',
              margin: '30px 30px 0 0',
              fontWeight: 'bold',
            }}
          >
            CARGO & PRODUCT DETAILS
          </Row>
          <Row
            gutter={24}
            style={{
              verticalAlign: 'middle',
              margin: '30px 30px 0 0',
            }}
          >
            <Row
              gutter={[0, 24]}
              style={{
                marginBottom: '0px',
                marginRight: '10px',
                verticalAlign: 'middle',
              }}
            >
              <Col id="grid#cargoAndProduct" className={classes.rowDiv}>
                <div>{renderCargoDetails()}</div>
              </Col>
              <Col style={{ display: 'flex', flexDirection: 'column', marginBottom: '22px' }}>
                <div id="grid#stackable">{renderStackableForRoadPTLWrapper()}</div>
              </Col>
            </Row>
            <div id="grid#packagingDetails">{renderPackagingDetailsWrapper()}</div>
            <div id="grid#productDetails">{renderCompleteProductDetails()}</div>
          </Row>
        </>
      )} */}
      <Row
        gutter={24}
        style={{
          verticalAlign: 'middle',
          margin: '30px 30px 0 0',
          fontWeight: 'bold',
        }}
      ></Row>
      {/* <Row
        gutter={24}
        style={{
          verticalAlign: 'middle',
          margin: '30px 30px 0 0',
          fontWeight: 'bold',
        }}
      >
        PACKAGING DETAILS
      </Row>
      <Row
        gutter={24}
        style={{
          verticalAlign: 'middle',
          margin: '30px 30px 0 0',
        }}
      >
        {renderPackagingDetails()}
      </Row> */}
      <Row
        gutter={24}
        style={{
          verticalAlign: 'middle',
          margin: '30px 30px 0 0',
        }}
      >
        <Col span={12}>
          {/* {renderStackable()} */}
          {renderInternalReferenceNumber()}
          {renderBusinessType()}
          {renderBusinessEntity()}
          {renderOtherDetails()}
          {customFieldsForInquiryDomestic?.shipmentName &&
            renderCustomTextField(
              customFieldsForInquiryDomestic?.shipmentName?.prettyName || 'Shipment Name',
              'shipmentName',
              (getFieldValue('isDraft') && draftMandatoryFields?.includes('shipmentName')) ||
                (!getFieldValue('isDraft') &&
                  customFieldsForInquiryDomestic?.shipmentName?.isMandatory) ||
                false,
              customFieldsForInquiryDomestic?.shipmentName?.default || undefined
            )}
          {customFieldsForInquiryDomestic?.requestor &&
            renderCustomTextField(
              customFieldsForInquiryDomestic?.requestor?.prettyName || 'Requestor',
              'requestor',
              (getFieldValue('isDraft') && draftMandatoryFields?.includes('requestor')) ||
                (!getFieldValue('isDraft') &&
                  customFieldsForInquiryDomestic?.requestor?.isMandatory) ||
                false,
              customFieldsForInquiryDomestic?.requestor?.default || undefined
            )}
          {customFieldsForInquiryDomestic?.serviceLevel &&
            renderCustomDropDown(
              customFieldsForInquiryDomestic?.serviceLevel?.prettyName || 'Service Level',
              'serviceLevel',
              customFieldsForInquiryDomestic?.serviceLevel?.dropDown || [],
              (getFieldValue('isDraft') && draftMandatoryFields?.includes('serviceLevel')) ||
                (!getFieldValue('isDraft') &&
                  customFieldsForInquiryDomestic?.serviceLevel?.isMandatory) ||
                false,
              customFieldsForInquiryDomestic?.serviceLevel?.default || undefined
            )}
          {customFieldsForInquiryDomestic?.typeOfMovement &&
            renderCustomDropDown(
              customFieldsForInquiryDomestic?.typeOfMovement?.prettyName || 'Type of Import/Export',
              'typeOfMovement',
              customFieldsForInquiryDomestic?.typeOfMovement?.dropDown || [],
              (getFieldValue('isDraft') && draftMandatoryFields?.includes('typeOfMovement')) ||
                (!getFieldValue('isDraft') &&
                  customFieldsForInquiryDomestic?.typeOfMovement?.isMandatory) ||
                false,
              customFieldsForInquiryDomestic?.typeOfMovement?.default || undefined
            )}
          {getFieldValue('isDraft') &&
            customFieldsForInquiryDomestic?.isDraftIncomplete &&
            renderCustomRadio(
              customFieldsForInquiryDomestic?.isDraftIncomplete?.prettyName || 'Draft Incomplete',
              'isDraftIncomplete',
              (getFieldValue('isDraft') && draftMandatoryFields?.includes('isDraftIncomplete')) ||
                (!getFieldValue('isDraft') &&
                  customFieldsForInquiryDomestic?.isDraftIncomplete?.isMandatory) ||
                false,
              customFieldsForInquiryDomestic?.isDraftIncomplete?.default || undefined
            )}
          {getFieldValue('isDraft') &&
            customFieldsForInquiryDomestic?.remarks &&
            renderCustomTextField(
              customFieldsForInquiryDomestic?.remarks?.prettyName || 'Remarks',
              'remarks',
              (getFieldValue('isDraft') && draftMandatoryFields?.includes('remarks')) ||
                (!getFieldValue('isDraft') &&
                  customFieldsForInquiryDomestic?.remarks?.isMandatory) ||
                false,
              customFieldsForInquiryDomestic?.remarks?.default || undefined
            )}
          {renderTermsAndConditions()}
          {renderReferenceRate()}
        </Col>
        {/* <Col span={4}></Col> */}
        <Col span={12}>
          <div style={{ marginLeft: '80px' }}>
            {renderIsHighValue()}
            {renderCargoValue()}
            {renderContractDuration()}
            {!isBooking
              ? renderCargoReadyOrClosingTime(
                  'Inquiry Closing Time',
                  'closingTime',
                  getFieldValue('isDraft') && !draftMandatoryFields?.includes('deadline')
                    ? undefined
                    : defaultDeadlineInHours
                    ? moment().add(defaultDeadlineInHours, 'hours')
                    : moment().endOf('day').add(2, 'day'),
                  (getFieldValue('isDraft') && draftMandatoryFields?.includes('deadline')) ||
                    !getFieldValue('isDraft')
                )
              : null}
            {renderCargoReadyOrClosingTime('Cargo Ready Date', 'cargoDate', undefined, false)}
            {renderDocumentUpload()}
            {/* {renderAdditionalDetails()} */}
          </div>
        </Col>
      </Row>

      {state.addProduct && <NewProduct handleClose={(success: boolean) => handleAddProduct()} />}

      {openNewLocationModal && (
        <AddLocationModal
          visible={openNewLocationModal}
          handleCancel={() => setState({ openNewLocationModal: false })}
          loadAddresses={loadAddresses}
          showLocationInput={true}
        />
      )}
      {openCFSLocationModal && (
        <AddCfsLocationModal
          visible={openCFSLocationModal}
          handleCancel={() => setState({ openCFSLocationModal: false })}
          loadAddresses={loadAddresses}
        />
      )}
    </>
  );
};

const mapStateToProps = ({ masterData, inquiryReducer, organisation }, ownProps) => ({
  cargoTypes: masterData.cargoTypeList,
  cargoList: masterData.cargoList,
  currencies: masterData.currencySymbols,
  orgMaster: organisation.orgMaster,
  organisationId: organisation.orgDetails.organisationId,
  orgCurrency: organisation?.orgDetails?.defaultCurrency ?? 'USD',
  domesticVehicleTypeSizeList: masterData.domesticVehicleTypeSizeList,
  defaultDistanceUnit: masterData?.inquiryDefaults?.defaultDistanceUnit,
  defaultDomesticVehicleSize: masterData?.inquiryDefaults?.defaultDomesticVehicleSize,
  defaultCargoSpecificGrossWeight: masterData?.inquiryDefaults?.defaultDomesticCargoSpecificGrossWeight,
  defaultVehicleSpecificTnC: masterData?.inquiryDefaults?.defaultVehicleSpecificTnC,
  weightsUnits: inquiryReducer.masterData.weightsUnits,
  termsAndConditions: inquiryReducer.masterData.termsAndConditions,
  isTemperatureControlledMandatory: masterData.modules.is_temperature_controlled_mandatory,
  businessEntities: inquiryReducer.masterData.businessEntities,
  reeferProductTempRange: inquiryReducer.masterData.reeferProductTempRange,
  defaultDeadlineInHours: inquiryReducer.masterData.defaultDeadlineInHours,
  masterData: inquiryReducer.masterData,
  customFieldsForInquiryDomestic: masterData?.customFieldsForInquiry?.DOMESTIC,
  draftMandatoryFields: masterData?.mandatoryFieldsInInquiryDraft?.DOMESTIC,
  userData: organisation?.userData,
  permissions: masterData.permissions,
  enableAddressMasterInMenu: masterData.modules.enable_address_master_in_menu || false,
  inquiryFormPrefill: masterData?.modules?.inquiry_form_prefill,
});

export default (connect(
  mapStateToProps,
  null,
  )(withStyles(styles)(React.memo(CreateDomesticInquiry)))
);
